import { LocaleKeys } from './translation-types'

export const en: Record<LocaleKeys, string> = {
  //download documents ----------------------------------------------------------------
  'downloadDocuments.loading': 'Generating file...',

  // enrollment ----------------------------------------------------------------
  'enrollment.notFound': 'Child not found',
  'enrollment.profile.pdf.title': 'Document preview',
  'enrollment.profile.pdf.label': 'Registration Form Sheet',
  'enrollment.profile.pdf.close': 'Close',
  'enrollment.profile.pdf.unlock': 'Unlock',
  'enrollment.profile.pdf.validate': 'Validate',

  //file ----------------------------------------------------------------
  'file.caption': 'Caption',
  'file.upload.placeholder': 'Drag and drop or browse',
  'file.upload.label': 'Upload file',

  // Bank Payment Status enum ----------------------------------------------------------------
  'center.ol.payment.status.enum.CREATED': 'Created',
  'center.ol.payment.status.enum.EXPORTED': 'Exported',
  'center.ol.payment.status.enum.VALIDATED': 'Validated',

  //gender enum ----------------------------------------------------------------
  'gender.enum.male': 'Male',
  'gender.enum.female': 'Female',

  //position status enum ----------------------------------------------------------------
  'position.status.fullTime': 'Full time',
  'position.status.partTime': 'Part time',

  //Conveyance type enum ----------------------------------------------------------------
  'conveyance.type.walk': 'Walk',
  'conveyance.type.bus': 'Bus',
  'conveyance.type.train': 'Train',

  //report status enum ----------------------------------------------------------------
  'report.status.enum.DRAFT': 'Draft',
  'report.status.enum.SENT': 'Sent',
  'report.status.enum.VALIDATED': 'Validated',

  //Language enum ----------------------------------------------------------------
  'language.enum.english': 'English',
  'language.enum.german': 'German',
  'language.enum.spanish': 'Spanish',

  //Translation locale ----------------------------------------------------------------
  'translation.locale.FR': 'French',
  'translation.locale.EN': 'English',
  'translation.locale.DE': 'German',
  'translation.locale.ES': 'Spanish',
  'translation.value.required': 'This field is required',

  //Document status enum ----------------------------------------------------------------
  'document.status.enum.VERIFIED': 'Verified',
  'document.status.enum.REFUSED': 'Refused',
  'document.status.enum.PENDING': 'Pending',
  'document.status.enum.RECEIVED': 'Received',

  //staff Document Type Enum Mapping ----------------------------------------------------------------
  'staff.document.type.enum.diploma': 'Diploma - {{diplomaTitle}}',
  'staff.document.type.enum.paySlip': 'Pay slip',
  'staff.document.type.enum.eta': 'ETA',
  'staff.document.type.enum.criminalRecord': 'Criminal record',
  'staff.document.type.enum.idFile': 'ID file',

  //staff qualification enum mapping ----------------------------------------------------------------
  'staff.qualification.enum.ACTIVITY_LEADER': 'Activity leader',
  'staff.qualification.enum.PROVINCE_CONVEYOR': 'Province conveyor',
  'staff.qualification.enum.BAFA_ANIMATOR': 'BAFA animator',
  'staff.qualification.enum.COORDINATING_PROFESSOR': 'Coordinating professor',
  'staff.qualification.enum.DEPUTY': 'Deputy',
  'staff.qualification.enum.DIRECTOR': 'Director',
  'staff.qualification.enum.FAC_PARIS': 'FAC Paris',
  'staff.qualification.enum.FAC_TERRAIN': 'FAC Terrain',
  'staff.qualification.enum.PROFESSOR_ENGLISH_COLLEGE': 'Professor English College',
  'staff.qualification.enum.FH_ANIMATOR': 'FH animator',
  'staff.qualification.enum.FOREIGN_CONVEYOR': 'Foreign conveyor',
  'staff.qualification.enum.PROFESSOR_ENGLISH': 'English professor',
  'staff.qualification.enum.PROFESSOR_ENGLISH_PREPA_SUP': 'Professor English Prepa Sup',
  'staff.qualification.enum.PROFESSOR_GERMAN': 'German professor',
  'staff.qualification.enum.PROFESSOR_SPANISH': 'Spanish professor',
  'staff.qualification.enum.REFERENT': 'Referent',
  'staff.qualification.enum.SANITARY_ASSISTANT_ANIMATOR': 'Sanitary assistant animator',
  'staff.qualification.enum.STATION_ASSISTANT': 'Station assistant',
  'staff.qualification.enum.SWIMMING_MONITOR_ANIMATOR': 'Swimming monitor animator',
  'staff.qualification.enum.TEFL': 'TEFL',
  'staff.qualification.enum.THEME_BASKETBALL_COACH': 'Thème - Basketball Coach',
  'staff.qualification.enum.THEME_BASKETBALL_TRAINER': 'Basketball trainer',
  'staff.qualification.enum.THEME_CHESS_COACH': 'Chess coach',
  'staff.qualification.enum.THEME_CHESS_TRAINER': 'Chess trainer',
  'staff.qualification.enum.THEME_DANCE_COACH': 'Dance coach',
  'staff.qualification.enum.THEME_DANCE_PROFESSOR': 'Dance professor',
  'staff.qualification.enum.THEME_DRAMA_COACH': 'Drama coach',
  'staff.qualification.enum.THEME_FOOTBALL_COACH': 'Football coach',
  'staff.qualification.enum.THEME_FOOTBALL_TRAINER': 'Football trainer',
  'staff.qualification.enum.THEME_MANGA_COACH': 'Manga coach',
  'staff.qualification.enum.THEME_MANGA_PROFESSOR': 'Manga professor',
  'staff.qualification.enum.THEME_MUSIC_COACH': 'Music coach',
  'staff.qualification.enum.THEME_MUSIC_PROFESSOR': 'Music professor',
  'staff.qualification.enum.THEME_TENNIS_COACH': 'Tennis coach',
  'staff.qualification.enum.THEME_TENNIS_TRAINER': 'Tennis trainer',
  'staff.qualification.enum.THEME_THEATER_PROFESSOR': 'Theater professor',
  'staff.qualification.enum.THEME_FOOTBALL_COACH_DAILY': 'Football coach (Daily)',
  'staff.qualification.enum.THEME_BASKETBALL_COACH_DAILY': 'Basketball coach (Daily)',
  'staff.qualification.enum.THEME_TENNIS_COACH_DAILY': 'Tennis coach (Daily)',
  'staff.qualification.enum.THEME_CHESS_COACH_DAILY': 'Chess coach (Daily)',
  'staff.qualification.enum.THEME_MANGA_COACH_DAILY': 'Manga coach (Daily)',
  'staff.qualification.enum.THEME_DANCE_COACH_DAILY': 'Dance coach (Daily)',
  'staff.qualification.enum.THEME_DRAMA_COACH_DAILY': 'Drama coach (Daily)',
  'staff.qualification.enum.THEME_MUSIC_COACH_DAILY': 'Music coach (Daily)',

  //ol staff qualification enum mapping (foreign OL spaces wording) ----------------------------------------------------------------
  'ol.staff.qualification.enum.ACTIVITY_LEADER': 'Activity Leader',
  'ol.staff.qualification.enum.PROVINCE_CONVEYOR': 'Courier',
  'ol.staff.qualification.enum.BAFA_ANIMATOR': 'Activity Leader',
  'ol.staff.qualification.enum.COORDINATING_PROFESSOR': 'English Teacher',
  'ol.staff.qualification.enum.DEPUTY': 'Assistant Camp Director',
  'ol.staff.qualification.enum.DIRECTOR': 'Camp Director',
  'ol.staff.qualification.enum.FAC_PARIS': 'French Area Coordinator - Paris',
  'ol.staff.qualification.enum.FAC_TERRAIN': 'French Area Coordinator',
  'ol.staff.qualification.enum.PROFESSOR_ENGLISH_COLLEGE': 'English Teacher',
  'ol.staff.qualification.enum.FH_ANIMATOR': 'Activity Leader',
  'ol.staff.qualification.enum.FOREIGN_CONVEYOR': 'Courier',
  'ol.staff.qualification.enum.PROFESSOR_ENGLISH': 'English Teacher',
  'ol.staff.qualification.enum.PROFESSOR_ENGLISH_PREPA_SUP': 'English Teacher',
  'ol.staff.qualification.enum.PROFESSOR_GERMAN': 'German Teacher',
  'ol.staff.qualification.enum.PROFESSOR_SPANISH': 'Spanish Teacher',
  'ol.staff.qualification.enum.REFERENT': 'Group Leader',
  'ol.staff.qualification.enum.SANITARY_ASSISTANT_ANIMATOR': 'Activity Leader',
  'ol.staff.qualification.enum.STATION_ASSISTANT': 'Courier',
  'ol.staff.qualification.enum.SWIMMING_MONITOR_ANIMATOR': 'Activity Leader',
  'ol.staff.qualification.enum.TEFL': 'TEFL',
  'ol.staff.qualification.enum.THEME_BASKETBALL_COACH': 'Basketball Coach',
  'ol.staff.qualification.enum.THEME_BASKETBALL_TRAINER': 'Basketball Coach',
  'ol.staff.qualification.enum.THEME_CHESS_COACH': 'Chess Coach',
  'ol.staff.qualification.enum.THEME_CHESS_TRAINER': 'Chess Coach',
  'ol.staff.qualification.enum.THEME_DANCE_COACH': 'Dance Coach',
  'ol.staff.qualification.enum.THEME_DANCE_PROFESSOR': 'Dance Coach',
  'ol.staff.qualification.enum.THEME_DRAMA_COACH': 'Drama Coach',
  'ol.staff.qualification.enum.THEME_FOOTBALL_COACH': 'Football Coach',
  'ol.staff.qualification.enum.THEME_FOOTBALL_TRAINER': 'Football Coach',
  'ol.staff.qualification.enum.THEME_MANGA_COACH': 'Manga Coach',
  'ol.staff.qualification.enum.THEME_MANGA_PROFESSOR': 'Manga Coach',
  'ol.staff.qualification.enum.THEME_MUSIC_COACH': 'Music Coach',
  'ol.staff.qualification.enum.THEME_MUSIC_PROFESSOR': 'Music Coach',
  'ol.staff.qualification.enum.THEME_TENNIS_COACH': 'Tennis Coach',
  'ol.staff.qualification.enum.THEME_TENNIS_TRAINER': 'Tennis Coach',
  'ol.staff.qualification.enum.THEME_THEATER_PROFESSOR': 'Drama Coach',
  'ol.staff.qualification.enum.THEME_FOOTBALL_COACH_DAILY': 'Football Coach Daily',
  'ol.staff.qualification.enum.THEME_BASKETBALL_COACH_DAILY': 'Basketball Coach Daily',
  'ol.staff.qualification.enum.THEME_TENNIS_COACH_DAILY': 'Tennis Coach Daily',
  'ol.staff.qualification.enum.THEME_CHESS_COACH_DAILY': 'Chess Coach Daily',
  'ol.staff.qualification.enum.THEME_MANGA_COACH_DAILY': 'Manga Coach Daily',
  'ol.staff.qualification.enum.THEME_DANCE_COACH_DAILY': 'Dance Coach Daily',
  'ol.staff.qualification.enum.THEME_DRAMA_COACH_DAILY': 'Drama Coach Daily',
  'ol.staff.qualification.enum.THEME_MUSIC_COACH_DAILY': 'Music Coach Daily',

  //staff position enum mapping ----------------------------------------------------------------
  'staff.position.enum.TEACHER': 'Teacher',
  'staff.position.enum.ANIMATOR': 'Instructor',
  'staff.position.enum.AAT': 'AAT',

  //ol staff position enum mapping (foreign OL spaces wording) ----------------------------------------------------------------
  'ol.staff.position.enum.TEACHER': 'Teacher',
  'ol.staff.position.enum.ANIMATOR': 'Activity Leader',
  'ol.staff.position.enum.AAT': 'Courier',

  //school Level Taught Enum Mapping ----------------------------------------------------------------
  'school.level.taught.enum.PRIMARY': 'Primary',
  'school.level.taught.enum.COLLEGE': 'College',
  'school.level.taught.enum.HIGH_SCHOOL': 'High school',
  'school.level.taught.enum.BTS_IUT_UNIVERSITY': 'BTS/IUT/University',
  'school.level.taught.enum.PREPARATORY_CLASSES': 'Preparatory classes',
  'school.level.taught.enum.OTHER': 'Other',

  // Center Status Enum Mapping ----------------------------------------------------------------
  'center.status.enum.OPEN': 'Open',
  'center.status.enum.OPEN.label': 'To be completed by OL',
  'center.status.enum.OPEN.activity.label': 'To complete',

  'center.status.enum.SENT_TO_LEC': 'Sent to LEC',
  'center.status.enum.SENT_TO_LEC.label': 'Sent to LEC',
  'center.status.enum.SENT_TO_LEC.activity.label': 'Sent to LEC',

  'center.status.enum.VALIDATED': 'Validated',
  'center.status.enum.VALIDATED.label': 'Validated by LEC',
  'center.status.enum.VALIDATED.activity.label': 'Validated by LEC',

  'center.status.enum.OPEN.travel.expense.label': 'To be completed',
  'center.status.enum.SENT_TO_LEC.travel.expense.label': 'Sent to LEC',
  'center.status.enum.VALIDATED.travel.expense.label': 'Validated by LEC',

  // Diploma Enum ----------------------------------------------------------------
  'diploma.enum.BAFA': 'BAFA',
  'diploma.enum.BAFD': 'BAFD',
  'diploma.enum.PSC1_AFPS': 'PSC1_AFPS',
  'diploma.enum.SB': 'SB',
  'diploma.enum.AGREGATION': 'Aggregation',
  'diploma.enum.CAPES': 'CAPES',
  'diploma.enum.PLP2': 'PLP2',
  'diploma.enum.MASTER': 'Master',
  'diploma.enum.LICENCE': 'Licence',
  'diploma.enum.TEFL_CELTA': 'TEFL CELTA',
  'diploma.enum.OTHER': 'Other',

  //marital Status Enum Mapping ----------------------------------------------------------------
  'marital.status.enum.SINGLE': 'Single',
  'marital.status.enum.COHABITATION': 'Living with partner',
  'marital.status.enum.PACS': 'PACS',
  'marital.status.enum.MARRIED': 'Married',
  'marital.status.enum.DIVORCED': 'Divorced',
  'marital.status.enum.WIDOW': 'Widowed',

  //accomodation Type Enum Mapping ----------------------------------------------------------------
  'accomodation.type.enum.FLAT': 'Flat',
  'accomodation.type.enum.HOUSE': 'House',
  'accomodation.type.enum.GARDEN': 'Garden',
  'accomodation.type.enum.NO_GARDEN': 'No Garden',

  //product type enum mapping ----------------------------------------------------------------
  'product.type.enum.NORMAL.title': 'Normal',
  'product.type.enum.NORMAL.label': 'Normal',
  'product.type.enum.ONE_TO_ONE.title': 'OTO',
  'product.type.enum.ONE_TO_ONE.label': 'One to One accompanied',
  'product.type.enum.ONE_TO_ONE_INDIVIDUAL.title': 'OTO Indiv',
  'product.type.enum.ONE_TO_ONE_INDIVIDUAL.label': 'One to One individual',
  'product.type.enum.CLUB_FOUR.title': 'Club 4',
  'product.type.enum.CLUB_FOUR.label': 'Club 4',

  'product.number.of.hours.per.week': '{{hours}}h of courses / week',

  //Leader Free Rate Enum Mapping ----------------------------------------------------------------
  'leader.free.rate.enum.ALL_LEADERS_FREE': 'All leaders free',
  'leader.free.rate.enum.NO_FREE_RATE': 'No free rate',
  'leader.free.rate.enum.ONE_PER_TEN': '1 free per 10',
  'leader.free.rate.enum.ONE_PER_FIFTEEN': '1 free per 15',
  'leader.free.rate.enum.ONE_PER_TWENTY': '1 free per 20',
  'leader.free.rate.enum.ONE_PER_TWENTY_FIVE': '1 free per 25',
  'leader.free.rate.enum.ONE_PER_THIRTY': '1 free per 30',

  // Transport Mode Enum Mapping ----------------------------------------------------------------
  'transport.mode.enum.BUS_PASS': 'Transport included in the bus pass',
  'transport.mode.enum.WALK': 'Walk',
  'transport.mode.enum.EXTRA_BUS_OR_TRAIN': 'Extra bus/train cost',

  // Outing Duration Enum Mapping ----------------------------------------------------------------
  'outing.duration.enum.FULL_DAY': 'Full day',
  'outing.duration.enum.HALF_DAY': 'Half day',

  // host family price type Enum Mapping ----------------------------------------------------------------
  'host.family.price.type.enum.STUDENT': 'Student',
  'host.family.price.type.enum.STAFF': 'French leader',

  //friend place enum mapping ----------------------------------------------------------------
  'friend.place.enum.SAME_FAMILY': 'Same HF',
  'friend.place.enum.SAME_CENTER': 'Same center',

  //trip step type enum mapping ----------------------------------------------------------------
  'trip.step.type.enum.INBOUND': 'Arrival',
  'trip.step.type.enum.OUTBOUND': 'Return',

  //TEFL Type Enum Mapping ----------------------------------------------------------------
  'tefl.type.enum.TUITION_ACTIVITY': 'Tuition + Activity',
  'tefl.type.enum.TUITION_ONLY': 'Tuition only',
  'tefl.type.enum.FULL_DAY_OUTING': 'Full day outing',
  'tefl.type.enum.ACTIVITY_ONLY': 'Activity only',

  //personality enum mapping -----------------------------------------------------------------
  'personality.enum.ENERGETIC': 'Energetic',
  'personality.enum.ARTISTIC': 'Artistic',
  'personality.enum.ATHLETIC': 'Athletic',
  'personality.enum.SHY': 'Shy',
  'personality.enum.SOCIABLE': 'Sociable',
  'personality.enum.STUDIOUS': 'Studious',
  'personality.enum.TALKATIVE': 'Talkative',
  'personality.enum.INDEPENDENT': 'Independent',

  //interest enum mapping -----------------------------------------------------------------
  'interest.enum.CITY': 'City',
  'interest.enum.COUNTRYSIDE': 'Countryside',
  'interest.enum.ANIMALS': 'Animals',

  //asthma severity enum mapping ----------------------------------------------------------------
  'asthma.severity.enum.MILD': 'Asthma mild',
  'asthma.severity.enum.SEVERE': 'Asthma severe',

  //filters ----------------------------------------------------------------
  'filters.apply': 'Apply',
  'filters.reset': 'Reset',
  'filters.title': 'Filter by',

  //RadioButton active state ----------------------------------------------------------------
  'radio.button.active': 'Active',
  'radio.button.inactive': 'Inactive',
  'radio.button.both': 'Both',

  //password placeholder ----------------------------------------------------------------
  'password.placeholder': 'Password',

  //forget password ----------------------------------------------------------------
  'forgot.password': 'Forgot your password?',
  'forgot.password.title': 'Welcome Back!',
  'forgot.password.subtitle': 'Forget Password',

  //Authenticate token ----------------------------------------------------------------
  'authenticate.token.error.hint': 'Request a new login link from your login page.',
  'authenticate.token.error.cta': 'Get a new login link',

  //Reset password ----------------------------------------------------------------
  'reset.password.title': 'Welcome Back!',
  'reset.password.subtitle': 'Reset Password',
  'reset.password.new': 'New password',

  //dynamic data table ----------------------------------------------------------------
  'dynamic.data.table.delete.label': 'Delete',
  'dynamic.data.table.delete.one.label': 'Are you sure you want to delete the {{message}}?',
  'dynamic.data.table.delete.many.label': 'Are you sure you want to delete the {{message}}?',
  'dynamic.data.table.delete.all.label': 'Are you sure you want to delete all the {{message}}?',
  'dynamic.data.table.delete.confirm': 'Confirm',
  'dynamic.data.table.delete.cancel': 'Close',
  'host.family.filters.status.label': 'Status',
  'host.family.filters.status.both': 'Both',
  'host.family.filters.status.deactivated': 'Deactivated',
  'host.family.filters.status.active': 'Active',
  'host.family.filters.city.label': 'City',
  'host.family.filters.town.label': 'Town',
  'host.family.filters.lec.comments.label': 'LEC comments',
  'host.family.filters.lec.comments.both': 'Both',
  'host.family.filters.lec.comments.has': 'Has comments',
  'host.family.filters.lec.comments.no': 'No comments',
  'host.family.filters.date.of.visit.label': 'Has hosted within the last 2 years',
  'host.family.filters.date.of.visit.all': 'All',
  'host.family.filters.date.of.visit.has': 'Has hosted',
  'host.family.filters.date.of.visit.no': 'Has not hosted',
  'host.family.forms.deactivation.label': 'Disable this family',
  'host.family.forms.deactivation.placeholder': 'Select a reason to disable this family',
  'host.family.forms.deactivation.info.message':
    "If you disable a family, they won't receive any notification",
  'host.family.forms.deactivation.submit.label': 'Save',
  'host.family.forms.deactivation.cancel.label': 'Close',
  'host.family.forms.deactivation.locked.by.lec':
    'Family deactivated by LEC (not suitable), only LEC can reactivate it',
  'host.family.deactivation.reason.enum.NOT_AVAILABLE_ANYMORE': 'No longer available',
  'host.family.deactivation.reason.enum.MOVED_AWAY': 'Has moved',
  'host.family.deactivation.reason.enum.NOT_SUITABLE': 'Not suitable',
  'host.family.local.representative.title': 'Local representative',

  'taught.level.enum.beginner': 'Beginner',
  'taught.level.enum.intermediate': 'Intermediate',
  'taught.level.enum.advanced': 'Advanced',

  'tefl.status.label': 'Status',
  'tefl.status.active': 'Active',
  'tefl.status.inactive': 'Inactive',
  'tefl.status.both': 'Both',
  'tefl.success.message': 'TEFL updated successfully',
  'tefl.history.title': 'Students appreciations per centre',
  'tefl.history.description': 'List of average ratings given by students per center (tuition)',
  'tefl.history.columns.centers': 'Centers',
  'tefl.history.columns.dates': 'Date of stay',
  'tefl.history.columns.formula': 'Programmes',
  'tefl.history.columns.average.rating': 'Average rating',
  'tefl.history.footer.average': 'Average',

  //errors ----------------------------------------------------------------
  'errors.string.required': 'Please enter {{fieldName}}',
  'errors.string.max': '{{fieldName}} characters are too long',
  'errors.string.email': 'Please enter a valid email ',
  'errors.string.list.required': 'Please enter values for {{fieldName}}',
  'errors.string.min.list':
    'Please enter at least {{minimumNumberOfItems}} elements for {{fieldName}}',

  'errors.date.required': 'Please enter {{inputName}}',
  'errors.date.invalid': 'Please enter a valid {{inputName}}',
  'errors.date.range': '{{inputName}} must be between {{minDate}} and {{maxDate}}.',
  'errors.date.max': '{{inputName}} must be on or before {{maxDate}}.',
  'errors.date.min': '{{inputName}} must be on or after {{minDate}}',

  'errors.time.required': 'Please enter {{fieldName}}',
  'errors.time.invalid': 'Please enter a valid {{fieldName}}',

  'errors.enum.required': 'Please select {{fieldName}}',
  'errors.enum.invalid': 'Please select a valid {{fieldName}}',
  'errors.enum.list.required': 'Please select values for {{fieldName}}',
  'errors.enum.list.min':
    'Please select at least {{minimumNumberOfItems}} elements for {{fieldName}}',

  'errors.social.security.number.invalid': 'Please enter a valid social security number',

  'errors.iban.invalid': 'Please enter a valid IBAN',
  'errors.iban.required': 'Please enter IBAN',
  'errors.iban.min': 'IBAN must be at least 27 characters long',
  'errors.iban.max': 'IBAN must be at most 34 characters long',
  'errors.iban.invalidUsdAccountNumber':
    'Please enter a valid account number (alphanumeric characters only)',

  'errors.number.required': 'Please enter {{fieldName}}',
  'errors.number.invalid': 'Please enter a valid {{fieldName}}',
  'errors.number.positive': '{{fieldName}} must be positive',
  'errors.number.integer': '{{fieldName}} must be an integer',
  'errors.number.min': '{{fieldName}} must be at least {{minimum}}',
  'errors.number.max': '{{fieldName}} must be at most {{maximum}}',
  'errors.number.nonNegative': '{{fieldName}} must be non-negative',
  'errors.number.decimalPlaces':
    '{{fieldName}} cannot have more than {{decimalPlaces}} decimal place(s)',
  'errors.number.list.required': 'Please enter values for {{fieldName}}',
  'errors.number.list.min':
    'Please enter at least {{minimumNumberOfItems}} elements for {{fieldName}}',

  'errors.password.min': 'Password must be at least 8 characters long',
  'errors.password.max': 'Password must be at most 20 characters long',
  'errors.password.invalid':
    'Password must contain at least one uppercase letter, one lowercase letter, one number and one special character',

  'errors.phone.required': 'Please enter a phone number',
  'errors.phone.invalid': 'Please enter a valid phone number',

  'errors.rich.text.required': 'Please enter a rich text',
  'errors.rich.text.invalid': 'Please enter a valid rich text.',

  'errors.part.of.the.europian.union': 'Please enter a valid country of the European Union',
  'errors.diploma.name.required': 'Please enter the name of the diploma',

  //buttons ----------------------------------------------------------------
  'button.validate.plus.one': 'Save +1',
  'button.validate.and.back.to.list': 'Save and return to the list',
  'button.validate': 'Save',
  'button.modal.validate.plus.one': 'Validate +1',
  'button.modal.validate.and.back.to.list': 'Validate and return to the list',
  'button.modal.validate': 'Validate',
  'button.close': 'Close',
  'button.return': 'Return',
  'button.add': 'Add',
  'button.continue': 'Continue',
  'button.confirm': 'Confirm',
  'button.cancel': 'Cancel',
  'button.delete': 'Delete',
  'button.submit': 'Submit',
  'button.assign': 'Assign',

  //Send Email ----------------------------------------------------------------
  'send.email.to': 'To:',
  'send.email.subject': 'Subject',
  'send.email.body': 'Write your message here',
  'send.email.attachments': 'Attach files',
  'send.email.attachments.upload': 'Drag and drop or browse',
  'send.email.send': 'Send',

  //file upload ----------------------------------------------------------------
  'file.upload.drag.and.drop': 'Drag and drop or browse',
  'file.upload.title': 'Upload document',
  'common.noImages': 'No images available',
  'common.click.to.enlarge': 'Click on an image to enlarge it',

  // common ----------------------------------------------------------------
  'common.no.comments': 'No comments',
  'common.no.feedback': 'No feedback',
  'common.year': 'Year',
  'common.days': 'days',
  'common.to': 'to',
  'common.back.to.admin.space': 'Back to admin space',
  'common.pagination.show': 'Show',
  'common.pagination.per.page': 'per page',
  'common.pagination.previous': 'Previous',
  'common.pagination.next': 'Next',
  'common.no.results': 'No results to display',
  'common.select.none': 'None',
  'common.select.add.option': 'Add "{{value}}"',
  'common.modal.accept': 'Accept',
  'common.status.toggle.active': 'Active',
  'common.status.toggle.inactive': 'Inactive',
  'center.groups.title': 'Sub-groups',
  'center.groups.students.assigned': '{{total}} students assigned',
  'center.groups.student.assigned': '{{total}} student assigned',
  'center.groups.documents': '{{total}} documents',
  'center.groups.document': '{{total}} document',
  'center.groups.no.tefl.assigned': 'No TEFL assigned',
  'center.groups.assign.tefl.title': 'Assign a TEFL',
  'center.groups.assign.tefl.select': 'Select a TEFL',
  'center.groups.assign.tefl.none': 'None',
  'center.groups.assign.tefl.success': 'TEFL assigned successfully',
  'center.groups.unassign.tefl.success': 'TEFL unassigned successfully',
  'center.groups.documents.title': 'Manage documents',
  'center.groups.documents.placeholder': 'Drag and drop or browse',
  'center.groups.documents.upload': 'Upload a document',
  'center.groups.documents.success': 'Document added successfully',
  'center.groups.view.students.title': 'View students - {{name}}',
  'center.groups.students.journeys': 'Stays',
  'center.groups.students.enrollment.number': 'Enrollment no.',
  'center.groups.students.last.name': 'LAST NAME',
  'center.groups.students.first.name': 'First name',
  'center.groups.students.age': 'Age',
  'center.groups.students.gender': 'Sex',
  'center.groups.students.class': 'Class',
  'center.groups.students.health': 'Health',
  'center.groups.students.friends': 'Associated friends',
  'center.groups.close': 'Close',
  'center.events.title': 'Student end of stay evaluation',
  'common.data.table.order': 'Order no.',
  'center.events.columns.type': 'Event type',
  'center.events.columns.created.at': 'Event created on',
  'center.events.columns.dates': 'Dates of stay',
  'center.events.columns.student': 'Student last name',
  'center.events.columns.assigned.to': 'Followed by',
  'center.events.columns.last.activity': 'Last activity',
  'center.events.columns.inactive.duration': 'Time inactive',
  'center.events.inactive.duration.days': '{{total}}d',
  'center.events.columns.country': 'Country',
  'center.events.columns.period': 'Period',
  'center.events.columns.status': 'Status',
  'center.event.type.enum.HEALTH': 'Health',
  'center.event.type.enum.DISCIPLINE': 'Discipline',
  'center.event.type.enum.ACCOMODATION': 'Accommodation / Food',
  'center.event.type.enum.COURSE': 'Lessons',
  'center.event.type.enum.ACTIVITY': 'Activities',
  'center.event.type.enum.TRAVEL': 'Travel',
  'center.event.type.enum.MONEY': 'Money',
  'center.event.type.enum.DIVERS': 'Miscellaneous',
  'center.event.type.enum.FA2E_NOT_WANTED': 'FA2E not wanted',
  'center.event.type.enum.SUPERVISION': 'Supervision',
  'center.event.type.enum.REPATRIATION': 'Repatriation',
  'center.event.type.enum.CLAIM': 'Complaint',
  'center.event.status.enum.CREATED': 'To assign',
  'center.event.status.enum.IN_PROGRESS': 'In progress',
  'center.event.status.enum.SOLVED': 'Closed',

  //STAFF PERSONAL SPACE ----------------------------------------------------------------
  'staff.personal.space': 'My personal space',
  'staff.personal.space.availability': 'Availability',
  'staff.personal.space.pay.scale': 'Pay scale',
  'staff.personal.space.my.journeys': 'My journeys',
  'staff.personal.space.my.journeys.home': 'Home',

  // address details ----------------------------------------------------------------
  'address.label': 'Place name',
  'address.address1.label': 'Address',
  'address.address2.label': 'Complementary address',
  'address.zipCode.label': 'Zip code',
  'address.details.city': 'City',

  //staff profile ----------------------------------------------------
  'staff.personal.space.academic.zone': 'Academic zone',
  'staff.personal.space.social.security.number': 'Social security number',
  'staff.personal.space.birth.date': 'Date of birth',
  'staff.personal.space.birth.place': 'Country of birth',
  'staff.personal.space.birth.department': 'Department of birth',
  'staff.personal.space.birth.city': 'City of birth',
  'staff.personal.space.spoken.languages': 'Spoken languages',

  //staff personal space my journeys -----------------------------------------------------
  'staff.personal.space.my.journeys.title': 'Journeys',
  'staff.personal.space.my.journeys.subtitle': 'All journeys',
  'staff.personal.space.my.journeys.information':
    'Access the information about your journey (guides, travel schedules, attendance lists, language test results, etc.)',
  'staff.personal.space.my.journeys.information.empty': 'No journeys found',

  //staff personal space my journey details -----------------------------------------------------
  'staff.personal.space.my.journeys.details.tab.home': 'Home',
  'staff.personal.space.my.journeys.details.tab.guide': 'Guides to read before your stay',
  'staff.personal.space.my.journeys.details.trip.time': 'My travel schedules',
  'staff.personal.space.my.journeys.details.students': 'List of Young People',
  'staff.personal.space.my.journeys.details.students.invalid.id.or.center.data':
    'Invalid ID or center data',
  'staff.personal.space.my.journeys.details.cannot.view.activities.and.budget':
    "You don't have the right to view the activities and budget program of this stay at the moment",
  'staff.personal.space.my.journeys.details.activities.and.budget':
    'Activities and Budget Program',
  'staff.personal.space.my.journeys.details.questionnaire': 'Supplementary Questionnaire',
  'staff.personal.space.my.journeys.details.expenses.note': 'My Expense Report',
  'staff.personal.space.my.journeys.details.daily.report': 'Daily Report',
  'staff.personal.space.my.journeys.details.end.of.stay.report': 'End of Stay Report',
  'staff.personal.space.my.journeys.details.end.of.stay.questions.residenceFacilities':
    'What did you think of the college/residence and its facilities?',
  'staff.personal.space.my.journeys.details.end.of.stay.questions.managementTeam':
    'What did you think of the management team?',
  'staff.personal.space.my.journeys.details.end.of.stay.questions.peersInvolvement':
    "What did you think of your colleagues' involvement?",
  'staff.personal.space.my.journeys.details.end.of.stay.questions.excursionsFeedback':
    'What did you think of the excursions/outings organised by LEC?',
  'staff.personal.space.my.journeys.details.end.of.stay.questions.activitiesEvenings.professors':
    'Teachers: What did you think of the activities and evenings offered at the college/residence?',
  'staff.personal.space.my.journeys.details.end.of.stay.questions.activitiesEvenings.animators':
    "Animators: What did you think of the teachers' participation in activities and evenings?",
  'staff.personal.space.my.journeys.details.end.of.stay.questions.classroomEquipment':
    'What did you think of the classrooms and teaching equipment (for teachers) or the material (for animators) available?',
  'staff.personal.space.my.journeys.details.end.of.stay.questions.foodQuality':
    'What did you think of the food in general?',
  'staff.personal.space.my.journeys.details.end.of.stay.questions.residenceImprovements':
    'Do you see any improvements to make for a stay in college/residence?',
  'staff.personal.space.my.journeys.details.end.of.stay.questions.additionalRemarks':
    'Additional remarks:',
  'staff.personal.space.my.journeys.details.expenses.okay.for.hotel': 'OK for hotel night',
  'staff.personal.space.my.journeys.details.expenses.sent.to.lec.at': 'Sent to LEC on {{date}}',
  'staff.personal.space.my.journeys.details.expenses.note.details.title':
    'Please note, for teachers residing in the provinces, LEC reimburses:',
  'staff.personal.space.my.journeys.details.expenses.note.details.1':
    'Return transport costs home ➜ Paris to get to the Pre-stay Preparation Meeting:',
  'staff.personal.space.my.journeys.details.expenses.note.details.2':
    'Return transport costs home ➜ Departure/return location to get to the departure/return location of the stay',
  'staff.personal.space.my.journeys.details.expenses.note.details.3':
    '<strong>Your total costs cannot exceed €170 per stay..</strong>',
  'staff.personal.space.my.journeys.details.expenses.note.details.4':
    'Beyond this package, in any event, <strong>LEC will not reimburse the amounts committed.</strong>',
  'staff.personal.space.my.journeys.details.expenses.note.details.5':
    '<strong>Apart from these costs, no other reimbursement (fuel costs, parking, tolls, meals, taxis, etc.) will be covered..</strong>',
  'staff.personal.space.my.journeys.details.expenses.note.sentence.1':
    'For each expense you have incurred, please complete the form below and attach the corresponding supporting document..',
  'staff.personal.space.my.journeys.details.expenses.note.sentence.2':
    'It is imperative that you send us all your expenses at once. Once this form has been validated, no other expenses for this stay can be added subsequently..',
  'staff.personal.space.my.journeys.details.expenses.trip.table.title':
    'Travel expenses incurred for your stay/mission',
  'staff.personal.space.my.journeys.details.expenses.preparatory.table.title':
    'Travel expenses incurred for the preparatory meeting',
  'staff.personal.space.my.journeys.details.expenses.trip.table.footer.add.label': 'Add',
  'staff.personal.space.my.journeys.details.expenses.preparatory.table.footer.add.label': 'Add',
  'staff.personal.space.my.journeys.details.expenses.table.header.date': 'Date',
  'staff.personal.space.my.journeys.details.expenses.table.header.details': 'Expense details',
  'staff.personal.space.my.journeys.details.expenses.table.header.currency': 'Currency',
  'staff.personal.space.my.journeys.details.expenses.table.header.amount': 'Amount',
  'staff.personal.space.my.journeys.details.expenses.table.header.amount.staff':
    'Entered amount (ME)',
  'staff.personal.space.my.journeys.details.expenses.table.header.amount.lec':
    'Validated amount (LEC)',
  'staff.personal.space.my.journeys.details.expenses.table.header.proof': 'Proof',
  'staff.personal.space.my.journeys.details.expenses.flat.fees':
    'Total (Maximum flat fee of {{flatFees}})',
  'staff.personal.space.my.journeys.details.expenses.total': 'Total',
  'staff.personal.space.my.journeys.details.expenses.save.and.continue': 'Save and continue later',
  'staff.personal.space.my.journeys.details.expenses.validate.and.send.to.lec':
    'Validate and send to LEC',

  'staff.personal.space.my.journeys.details.expenses.validation.error':
    'Please ensure all fields are filled out correctly',

  'staff.personal.space.my.journeys.details.expenses.submission.success':
    'Your reimbursement request has been successfully submitted.',

  //staff personal space my journey details Home -----------------------------------------------------
  'staff.personal.space.my.journeys.details.tab.home.title': 'Home',

  'staff.personal.space.my.journeys.details.tab.home.journey.info.title': 'Journey Information',
  'staff.personal.space.my.journeys.details.tab.home.journey': 'Journey',
  'staff.personal.space.my.journeys.details.tab.home.journey.day': 'day(s)',
  'staff.personal.space.my.journeys.details.tab.home.journey.night': 'night(s)',
  'staff.personal.space.my.journeys.details.tab.home.journey.qualification': 'Qualification',
  'staff.personal.space.my.journeys.details.tab.home.journey.themes': 'Theme(s)',
  'staff.personal.space.my.journeys.details.tab.home.journey.options': 'Option(s)',
  'staff.personal.space.my.journeys.details.tab.home.journey.formulas': 'Formula(s)',

  'staff.personal.space.my.journeys.details.tab.home.trip': 'Trip',
  'staff.personal.space.my.journeys.details.tab.home.view.trip.data': 'View my travel schedule',

  'staff.personal.space.my.journeys.details.tab.home.teaching.halls.not.found':
    'No teaching hall found',
  'staff.personal.space.my.journeys.details.tab.home.teaching.halls': 'Teaching Halls',
  'staff.personal.space.my.journeys.details.tab.home.teaching.halls.name': 'Name',
  'staff.personal.space.my.journeys.details.tab.home.teaching.halls.address': 'Address',

  'staff.personal.space.my.journeys.details.tab.home.organizer.local': 'Local Organizer (OL)',
  'staff.personal.space.my.journeys.details.tab.home.organizer.firstName': 'First Name',
  'staff.personal.space.my.journeys.details.tab.home.organizer.lastName': 'Last Name',
  'staff.personal.space.my.journeys.details.tab.home.organizer.phone': 'Phone Number',
  'staff.personal.space.my.journeys.details.tab.home.organizer.email': 'Email',

  'staff.personal.space.my.journeys.details.tab.home.rad.title': 'Information Meeting',
  'staff.personal.space.my.journeys.details.tab.home.rad.date': 'Date',
  'staff.personal.space.my.journeys.details.tab.home.rad.hour': 'Hour',
  'staff.personal.space.my.journeys.details.tab.home.rad.location': 'Location',

  'staff.personal.space.my.journeys.details.tab.guide.cta': 'Discover the complete guide',
  'staff.personal.space.my.journeys.details.tab.guide.no.guides': 'No guides available yet',

  'staff.personal.space.my.journeys.details.tab.home.urgent.number.title': 'Emergency Number',
  'staff.personal.space.my.journeys.details.tab.home.urgent.number.text':
    'To be contacted only during the stay, outside office hours',
  'staff.personal.space.my.journeys.details.tab.home.urgent.number.lec': 'LEC Emergency Number',
  'staff.personal.space.my.journeys.details.tab.home.urgent.number.view.fac':
    'View FAC Paris numbers',

  'staff.personal.space.my.journeys.details.tab.home.urgent.number.modal.title':
    'Emergency Contacts LEC Paris',
  'staff.personal.space.my.journeys.details.tab.home.urgent.number.modal.lec.office.number':
    'LEC Office Number in Paris',
  'staff.personal.space.my.journeys.details.tab.home.urgent.number.modal.lec.french.hour':
    'French Time',
  'staff.personal.space.my.journeys.details.tab.home.urgent.number.modal.lec.monday.thursday':
    'Monday - Thursday',
  'staff.personal.space.my.journeys.details.tab.home.urgent.number.modal.lec.friday.saturday':
    'Friday - Saturday',
  'staff.personal.space.my.journeys.details.tab.home.urgent.number.modal.lec.FAC.numbers.title':
    'FAC Paris Numbers',
  'staff.personal.space.my.journeys.details.tab.home.urgent.number.modal.lec.FAC.numbers.text':
    'To be contacted as a priority in case of problems during the stay',
  'staff.personal.space.my.journeys.details.tab.home.urgent.number.modal.lec.journey':
    'Emergency Number Journey',
  'staff.personal.space.my.journeys.details.tab.home.urgent.number.modal.lec.journey.text':
    'To be contacted only during the stay, outside office hours and if the FAC Paris do not respond',

  'staff.personal.space.my.journeys.details.tab.home.my.team': 'My Team',

  'staff.personal.space.my.journeys.details.tab.home.contact.details.host.family':
    'Host Family Contact Details',
  'staff.personal.space.my.journeys.details.tab.home.contact.accommodation':
    'Accommodation Contact Details',

  'staff.personal.space.my.journeys.details.tab.home.contact.details.host.family.mrs': 'Madam',
  'staff.personal.space.my.journeys.details.tab.home.contact.details.host.family.mr': 'Sir',
  'staff.personal.space.my.journeys.details.tab.home.contact.details.host.family.empty':
    'No host family assigned yet',

  // staff personal space my journeys details activities
  'staff.personal.space.my.journeys.details.tab.home.activities.download.program':
    'Download Program',
  'staff.personal.space.my.journeys.details.tab.home.activities.download.program.with.budget':
    'Download Detailed Program with Budget',

  // Travel Expenses -----------------------------------------------------
  'travel.expenses.validate': 'Validate',
  'travel.expenses.open': 'Unlock',
  'travel.expenses.open.for.staff': 'Unlock for the supervisor',
  'travel.expenses.validation.error': 'Please ensure that all fields are correctly filled out.',
  'travel.expenses.validation.save': 'Save',
  'travel.expenses.submission.success':
    'Your reimbursement request has been successfully submitted.',
  'travel.expenses.table.header.proof': 'Supporting document',
  'travel.expenses.preparatory.table.title':
    'Travel expenses incurred for the preparatory meeting',
  'travel.expenses.preparatory.table.footer.add.label': 'Add',
  'travel.expenses.trip.table.title': 'Travel expenses incurred for your stay / assignment',
  'travel.expenses.trip.table.footer.add.label': 'Add',

  //staff login -----------------------------------------------------
  'staff.personal.space.connect': 'To connect',
  'staff.personal.space.welcome': 'Welcome to your\npersonal STAFF space',

  //Staff form --------------------------------------------------------
  'staff.personal.space.personal.info': 'Personal information',
  'staff.personal.space.contracts': 'My contracts',
  'staff.personal.space.missions': 'My missions',
  'staff.personal.space.to.complete': 'To complete',
  'staff.personal.space.my.profile': 'My profile',
  'staff.personal.space.progress.percentage': 'of your information is completed',
  'staff.personal.space.missing.documents': 'Missing documents:',
  'staff.personal.space.missing.iban': 'IBAN',
  'staff.personal.space.missing.emergency.contact.details': 'Emergency contact details',
  'staff.personal.space.address': 'Address',
  'staff.personal.space.postal.code': 'Postal code',
  'staff.personal.space.city': 'City',
  'staff.personal.space.country': 'Country',
  'staff.personal.space.supplementary.address': 'Supplementary address details',
  'staff.personal.space.civil.status': 'Civil status',
  'staff.personal.space.number.of.children': 'Number of children',
  'staff.personal.space.hobbies': 'Hobbies',
  'staff.personal.space.allergies': 'Allergies',
  'staff.personal.space.professional.details': 'Professional details',
  'staff.personal.space.current.status': 'Current status',
  'staff.personal.space.field.of.study': 'Field of study',
  'staff.personal.space.education.level': 'Education level',
  'staff.personal.space.taught.class.level': 'Taught class level',
  'staff.personal.space.establishments': 'Establishments',
  'staff.personal.space.establishment.name': 'Establishment name',
  'staff.personal.space.establishment.city': 'Establishment city',
  'staff.personal.space.establishment.address': "Establishment's address",
  'staff.personal.space.establishment.postal.code': "Establishment's postal code",
  'staff.personal.space.diplomas': 'Diplomas',
  'staff.personal.space.diplomas.info': 'Add a copy of each diploma you claim to hold',
  'staff.personal.space.other': 'Other',
  'staff.personal.space.degree.name': 'Degree name',
  'staff.personal.space.adminstrative.files': 'Administrative files',
  'staff.personal.space.identity.document': 'Identity document',
  'staff.personal.space.identity.subtitle': 'With which you will travel',
  'staff.personal.space.identity.card': 'Identity card',
  'staff.personal.space.identity.card.first.info':
    'Enter the information as it appears<br/>on the identity document with which<br/>you will travel and present during<br/>identity checks and travel formalities<br/>(check-in, police checks, etc.).',
  'staff.personal.space.identity.card.second.info':
    'As a reminder, your identity document must be valid<br/>until the end of your stay, and 6 months after the<br/>end of your stay for stays in the USA,<br/>Canada and Australia.',
  'staff.personal.space.identity.card.third.info':
    'In case of input errors or incorrect<br/>information, you will unfortunately be<br/>denied departure and will not be able<br/>to supervise the trip. The return to<br/>your home would then be at your<br/>own expense.',
  'staff.personal.space.passport': 'Passport',
  'staff.personal.space.date.of.issue': 'Date of issue',
  'staff.personal.space.expiration.date': 'Expiration date',
  'staff.personal.space.issuing.country': 'Issuing country',
  'staff.personal.space.payslip': 'Payslip',
  'staff.personal.space.payslip.subtitle':
    'Add your most recent payslip to confirm that you<br/>you are a member of the French education system, and to<br/>verify your CAPES, PLP2 or Agrégation for<br/>your bonus',
  'staff.personal.space.DBS': 'DBS',
  'staff.personal.space.DBS.subtitle': 'Dated less than 3 months',
  'staff.personal.space.DBS.first.info':
    'Add an extract from your criminal record less than 3<br/>months old.',
  'staff.personal.space.DBS.second.info':
    'To obtain an extract from your criminal record,<br/>go to: ',
  'staff.personal.space.eta.subtitle':
    'Your visa exemption if you are supervising a stay in England, Scotland, USA, or Canada',
  'staff.personal.space.your.bank.details': 'Your bank details',
  'staff.personal.space.bank.info':
    'The bank details entered must strictly be <br/>those of a UK bank account in your full <br/>name. In case of an input error, the <br/>payment processing time for your fees <br/>will be extended.',
  'staff.personal.space.has.complementary.insurance': 'Do you have complementary insurance?',
  'staff.personal.space.complementary.insurance.name': 'Complementary insurance name',
  'staff.personal.space.in.case.of.emergency': 'In case of emergency',
  'staff.personal.space.in.case.of.emergency.info':
    'Please enter the contact details of a person to reach<br/>in case of emergency during your stay',
  'staff.personal.space.emergency.contact.name': 'Emergency contact name',
  'staff.personal.space.emergency.contact.relationship': 'Emergency contact relationship',
  'staff.personal.space.phone.number': 'Phone number',
  'staff.personal.space.nationality': 'Nationality',
  'staff.personal.space.date.of.birth': 'Date of birth',
  'staff.personal.space.country.of.birth': 'Country of birth',
  'staff.personal.space.city.of.birth': 'City of birth',
  'staff.personal.space.diploma.name': 'Diploma name',
  'staff.personal.space.diploma': 'Diploma',
  'sso.login.success': 'Please check your email for the link to connect to your personal space.',

  // staff contracts ----------------------------------------------------------------
  'staff.personal.space.contracts.dates': 'Date du contrat',
  'staff.personal.space.contracts.country': 'Pays',
  'staff.personal.space.contracts.position': 'Poste',
  'staff.personal.space.contracts.qualification': 'Qualification',
  'staff.personal.space.contracts.net.remuneration.before.PASE': 'Rémunération nette avant PAS',
  'staff.personal.space.contracts.status': 'Status',
  'staff.personal.space.contracts.date.of.signature': 'Date de signature',
  'staff.personal.space.contracts.view': 'View my contract',
  'staff.personal.space.mission.date': 'Date mission',
  'staff.personal.space.mission.title': 'Libellé',
  'staff.personal.space.mission.pay': 'Rémunération',
  'staff.personal.space.mission.contract.sent.at': "Date d'envoi",
  'staff.personal.space.mission.contract.signed.at': 'Date de signature',

  // staff missions ----------------------------------------------------------------
  'staff.personal.space.missions.date': 'Mission date',
  'staff.personal.space.missions.title': 'Title',
  'staff.personal.space.missions.meeting.place': 'Meeting point',
  'staff.personal.space.missions.appointment.time': 'Meeting time',
  'staff.personal.space.missions.instructions': 'Mission instructions',
  'staff.personal.space.missions.repport': 'Mission report',
  'staff.personal.space.missions.repport.view': 'View mission report',
  'staff.personal.space.missions.repport.complete': 'Complete mission report',
  'staff.personal.space.missions.notes': 'Expense report',

  'staff.personal.space.missions.instructions.print.pdf': 'Open PDF',
  'staff.personal.space.missions.instructions.notes.access': 'Access',
  'staff.personal.space.missions.instructions.notes.add': 'Add',

  'staff.personal.space.missions.report.title': 'Mission Report',
  'staff.personal.space.missions.report.mission.date': 'Mission date',
  'staff.personal.space.missions.report.mission.title': 'Mission title',
  'staff.personal.space.missions.report.mission.meeting.place': 'Meeting point',
  'staff.personal.space.missions.report.start.time': 'Start time',
  'staff.personal.space.missions.report.end.time': 'End time',
  'staff.personal.space.missions.report.content.title':
    'Report on the course of the mission – to be completed at the end of the mission:',
  'staff.personal.space.missions.report.content.placeholder':
    'Please describe how the mission went, any incidents that occurred, the behavior of the students, etc.',
  'staff.personal.space.missions.report.comments.title':
    'Additional comments – to be completed if necessary:',
  'staff.personal.space.missions.report.comments.placeholder': 'Comments...',
  'staff.personal.space.missions.report.content.error': 'Please enter the mission report content.',

  //STAFF PERSONAL SPACE AVAILABILITY ----------------------------------------------------------------
  'staff.personal.space.availability.title': 'Your availability as well as the assigned stays',
  'staff.personal.space.availability.first.information.part.one':
    'Here, you can manage your availability.',
  'staff.personal.space.availability.first.information.part.two':
    'To add a new availability period, simply select a date range on the calendar (minimum 6 consecutive days).',
  'staff.personal.space.availability.first.information.part.two.aat':
    'To add a new availability period, simply select a date range on the calendar.',
  'staff.personal.space.availability.first.information.part.three':
    'To modify or delete an existing period, just click on it.',
  'staff.personal.space.availability.second.information.part.one': 'You can also',
  'staff.personal.space.availability.second.information.part.two':
    "select the formulas you'd like to supervise,",
  'staff.personal.space.availability.second.information.part.three':
    "as well as the destinations you'd like to supervise your next language stay.",
  'staff.personal.space.availability.list.of.countries': 'List of countries',
  'staff.personal.space.availability.formula.wishlist': 'Formula wishlist',
  'staff.personal.space.availability.add.availability': 'Add availability',
  'staff.personal.space.availability.month': 'Monthly',
  'staff.personal.space.availability.year': 'Yearly',
  'staff.personal.space.availability.contract': 'Contract',
  'staff.personal.space.availability.contract.from': 'from',
  'staff.personal.space.availability.mission': 'Mission',
  'staff.personal.space.availability.Avaialable.from': 'Available from',
  'staff.personal.space.availability.to': 'to',
  'staff.personal.space.availability.new.availability': 'New availability',
  'staff.personal.space.availability.edit.availability': 'Modify the availability',
  'staff.personal.space.availability.form.date.from': 'Date from',
  'staff.personal.space.availability.form.date.to': 'Date to',
  'staff.personal.space.availability.form.delete.message':
    'Are you sure you want to delete this availability?',

  //STAFF PERSONAL SPACE PAY SCALE ----------------------------------------------------------------
  'staff.personal.space.pay.scale.title': 'Payment scale for {{position}}',
  'staff.personal.space.pay.scale.terms.note':
    'Terms and conditions for reimbursement of your transportation costs',
  'staff.personal.space.pay.scale.Box.title':
    'Net remunerations before the application of withholding tax.',
  'staff.personal.space.pay.scale.Box.first.info.title':
    'For teaching professors: Qualification Bonus for CAPES and/or Agrégation',
  'staff.personal.space.pay.scale.Box.first.info.title.explanation':
    'Diploma in your possession on the day of recruitment',
  'staff.personal.space.pay.scale.Box.first.info.one': 'For stays of 7, 8, and 12 days:',
  'staff.personal.space.pay.scale.Box.first.info.two': 'For stays longer than 12 days:',
  'staff.personal.space.pay.scale.Box.first.general':
    'This bonus does not apply to stays without teaching sessions: One to One, Club 4, international colleges, and all formats in Malta.',
  'staff.personal.space.pay.scale.Box.second.info.title': 'LEC covers:',
  'staff.personal.space.pay.scale.Box.second.info.one':
    'Accommodation, full board, and laundry in College/Residence',
  'staff.personal.space.pay.scale.Box.second.info.two':
    'Round-trip travel expenses from the group’s departure city to the destination city',
  'staff.personal.space.pay.scale.Box.third.info.title':
    'Please note, for {{position}} residing in the provinces, LEC reimburses:',
  'staff.personal.space.pay.scale.Box.third.info.one': 'Round-trip transport expenses home to',
  'staff.personal.space.pay.scale.Box.third.info.one.two':
    'Paris for the preparatory meeting before the stay',
  'staff.personal.space.pay.scale.Box.third.info.two': 'Round-trip transport expenses home to',
  'staff.personal.space.pay.scale.Box.third.info.two.two':
    'The departure/return location to get to the stay’s departure/return point',
  'staff.personal.space.pay.scale.Box.third.info.three':
    'Your total expenses cannot exceed €210 per stay.',
  'staff.personal.space.pay.scale.Box.third.general.light':
    'Beyond this allowance, under all circumstances, ',
  'staff.personal.space.pay.scale.Box.third.general.bold':
    'LEC will not reimburse the incurred expenses.',
  'staff.personal.space.pay.scale.Box.general.ending.one':
    'Apart from these expenses, no other reimbursements (fuel, parking, tolls, meals, taxi, etc.) will be covered.',
  'staff.personal.space.pay.scale.Box.general.ending.two':
    '*The remuneration for stays of 8 days (all formats, all countries), 14 and 15 days (PO Malta stay only) includes 1 day of paid leave.',

  //STAFF PERSONAL SPACE PAY SCALE TABLE -------------------------------------------------
  'staff.personal.space.pay.scale.table.per.day': 'Per day ({{currency}})',
  'staff.personal.space.pay.scale.table.per.8.days': 'Per 8 days* ({{currency}})',
  'staff.personal.space.pay.scale.table.per.13.days': 'Per 13 days ({{currency}})',
  'staff.personal.space.pay.scale.table.per.14.days': 'Per 14 days ({{currency}})',
  'staff.personal.space.pay.scale.table.per.14.days.malta': 'Per 14 days* ({{currency}})',

  //STAFF PERSONAL SPACE PAY SCALE AAT ---------------------------------------------------
  'staff.personal.space.pay.scale.aat.title': 'Pay scale for Reception and Transfer Leaders',
  'staff.personal.space.pay.scale.aat.table.title': 'Label',
  'staff.personal.space.pay.scale.aat.table.qualification': 'Qualification',
  'staff.personal.space.pay.scale.aat.table.pay': 'Pay (€)',

  // STAFF PERSONAL SPACE TRAVEL SCHEDULE -------------------------------------------------
  'staff.personal.space.travel.schedule.reminder.about.the.expense.reimbursement.policy':
    'At the end of your stay, your responsibility ends once all the students have been handed over to their parents or a LEC representative. If you have a train to catch afterwards to get home, allow at least 1 hour of margin after the scheduled return time (without counting the time it takes to get to the next train station).',
  'staff.personal.space.travel.schedule.my.meeting.points': 'My schedules and meeting points',
  'staff.personal.space.travel.schedule.schedules.not.available.yet':
    'Your travel schedules will be published at the latest 20 days before your departure. You will receive an email notification as soon as they are available.',
  'staff.personal.space.travel.schedule.french.leader.meetings.instructions.one':
    'You will find below your schedules and meeting points. By clicking on the name of the place, you can access more details.',
  'staff.personal.space.travel.schedule.french.leader.meetings.instructions.two':
    'If you are coming from a province, please book your tickets as soon as possible to reach the departure point. If possible, prefer cancellable and/or modifiable tickets.',
  'staff.personal.space.travel.schedule.french.leader.meetings.instructions.attention':
    'Reminder of the reimbursement modalities',

  'staff.personal.space.travel.schedule.dispatch.place.card.date.of.departure': 'Departure date',
  'staff.personal.space.travel.schedule.dispatch.place.card.date.of.arrival': 'Arrival date',
  'staff.personal.space.travel.schedule.dispatch.place.card.departure.address':
    'Departure address',
  'staff.personal.space.travel.schedule.dispatch.place.card.arrival.address': 'Arrival address',
  'staff.personal.space.travel.schedule.dispatch.place.card.rdv.meeting.time': 'RDV meeting time',
  'staff.personal.space.travel.schedule.dispatch.place.card.company': 'Company',
  'staff.personal.space.travel.schedule.dispatch.place.card.arrival.time': 'Arrival time',
  'staff.personal.space.travel.schedule.dispatch.place.card.departure.place': 'Departure place',
  'staff.personal.space.travel.schedule.dispatch.place.card.arrival.place': 'Arrival place',
  'staff.personal.space.travel.schedule.dispatch.place.card.departure.time': 'Departure time',

  'staff.personal.space.travel.schedule.checklist.title':
    'Checklist of things to plan for the day of departure',
  'staff.personal.space.travel.schedule.checklist.subtitle': 'The essentials for your departure',
  'staff.personal.space.travel.schedule.checklist.item.one':
    'Check and prepare your identity documents',
  'staff.personal.space.travel.schedule.checklist.item.two': 'To avoid unnecessary stress',
  'staff.personal.space.travel.schedule.checklist.item.two.details':
    'arrive at least 1 hour before the meeting point',
  'staff.personal.space.travel.schedule.checklist.item.three':
    'Wear your red jacket and present yourself to the LEC departure supervisor',
  'staff.personal.space.travel.schedule.checklist.item.four':
    "Don't forget the documents handed over at the preparation meeting",
  'staff.personal.space.travel.schedule.checklist.item.five':
    'Remember to take your meal basket for the day of departure',
  'staff.personal.space.travel.schedule.checklist.item.one.one.title': 'England and Scotland',
  'staff.personal.space.travel.schedule.checklist.item.one.one.details':
    'Passport + ETA (to be requested on the official website)',
  'staff.personal.space.travel.schedule.checklist.item.one.two.title':
    'Ireland, Malta, Germany, Spain, France',
  'staff.personal.space.travel.schedule.checklist.item.one.two.details': 'ID card or passport',
  'staff.personal.space.travel.schedule.checklist.item.one.three.title': 'United States',
  'staff.personal.space.travel.schedule.checklist.item.one.three.details':
    'Passport + ESTA (to be requested on the official website)',
  'staff.personal.space.travel.schedule.checklist.item.one.four.title': 'Canada',
  'staff.personal.space.travel.schedule.checklist.item.one.four.details':
    'Passport + AVE (to be requested on the official website)',

  'staff.personal.space.travel.schedule.group.itinerary.title':
    'Group itinerary that I am supervising during the journey',
  'staff.personal.space.travel.schedule.group.itinerary.foreign.provider.place.lable':
    'RDV place {{name}} foreign provider',
  'staff.personal.space.travel.schedule.foreign.leader.checklist.item.one.title':
    'To avoid unnecessary stress',
  'staff.personal.space.travel.schedule.foreign.leader.checklist.item.one.details':
    'Arrive at least 1 hour before the meeting point',
  'staff.personal.space.travel.schedule.foreign.leader.checklist.item.two.one': 'Wear your',
  'staff.personal.space.travel.schedule.foreign.leader.checklist.item.two.two': 'red jacket',
  'staff.personal.space.travel.schedule.foreign.leader.checklist.item.two.three':
    'and present yourself to the',
  'staff.personal.space.travel.schedule.foreign.leader.checklist.item.two.four':
    'LEC departure supervisor',
  'staff.personal.space.travel.schedule.foreign.leader.options.title':
    'You have the option to either join the group at {{meetingPlace}}, or to travel to the school by your own means. Which option do you prefer?',
  'staff.personal.space.travel.schedule.foreign.leader.options.title.attend.alone':
    'You will travel to the school by your own means. Please confirm this choice.',
  'staff.personal.space.travel.schedule.foreign.leader.options.join.group':
    'I will join the group at {{meetingPlace}}',
  'staff.personal.space.travel.schedule.foreign.leader.options.join.group.generic':
    'I will join the group',
  'staff.personal.space.travel.schedule.foreign.leader.options.attend.alone':
    'I will travel to the school by my own means',

  'staff.personal.space.travel.schedule.foreign.leader.options.join.group.departure.label':
    'You are expected :',
  'staff.personal.space.travel.schedule.foreign.leader.options.join.group.rdv.hour': 'RDV hour',
  'staff.personal.space.travel.schedule.foreign.leader.options.join.group.rdv.place': 'RDV place',
  'staff.personal.space.travel.schedule.foreign.leader.options.join.group.dropoff.hour':
    'Drop-off time',
  'staff.personal.space.travel.schedule.foreign.leader.options.join.group.dropoff.place':
    'Drop-off place',
  'staff.personal.space.travel.schedule.foreign.leader.options.join.group.contact.label':
    'Contact of other leaders to find at the RDV point:',
  'staff.personal.space.travel.schedule.foreign.leader.options.join.group.note':
    'You can contact the other leaders of the trip if you have difficulty finding the car. If they do not respond, you can also find the person based in the arrival hall of St Pancras (she wears a red jacket "LEC" and ensures that the groups find the car at their arrival)',
  'staff.personal.space.travel.schedule.foreign.leader.options.join.group.bus.text':
    'The bus will drop you off :',

  'staff.personal.space.travel.schedule.foreign.leader.attend.alone.return.text':
    'You can leave the college from 11h. ',
  'staff.personal.space.travel.schedule.foreign.leader.attend.alone.departure.text':
    'You are expected at the following address :',
  'staff.personal.space.travel.schedule.foreign.leader.attend.alone.address.label': 'Address',
  'staff.personal.space.travel.schedule.foreign.leader.attend.alone.time.label': 'Time',
  'staff.personal.space.travel.schedule.foreign.leader.attend.alone.responsible.label':
    'Center supervisor :',
  'staff.personal.space.travel.schedule.foreign.leader.attend.alone.note':
    'Please contact the center supervisor upon arrival at the college',

  'staff.personal.space.travel.schedule.group.itinerary.no.reservations':
    'No reservations available',
  'staff.personal.space.travel.schedule.group.itinerary.reservation.title':
    'Reservations (all times are in local time)',
  'staff.personal.space.travel.schedule.group.itinerary.reservation.arrival.label': 'Arrival',
  'staff.personal.space.travel.schedule.group.itinerary.reservation.departure.label': 'Departure',
  'staff.personal.space.travel.schedule.group.itinerary.reservation.departure.transfer.title':
    'Transfer to the arrival in the country of stay',
  'staff.personal.space.travel.schedule.group.itinerary.reservation.return.transfer.title':
    'Transfer from your resort to the train station/airport/port',
  'staff.personal.space.travel.schedule.group.itinerary.foreign.provider.appointment.label':
    'Appointment time for foreign service provider {{name}}',

  //COMMISIONS ----------------------------------------------------------------
  'commissions.appliedToHost.header': 'Host type',
  'commissions.products.header': 'Programs',
  'commissions.formulas.header': 'Formulas',
  'commissions.countries.header': 'Countries',
  'commissions.countries.hours.per.day': 'hours/day',
  'commissions.hours.per.week.header': 'Tuition hours / week',
  'commissions.fa1ePrice.header': 'Fee per night FA1E',
  'commissions.fa1ePrice.per.week.header': 'Total fee/week FA1E (7 nights)',
  'commissions.ol.fees.per.fa1ePrice.header': 'LO Fee per FA1E (French students and leaders)',
  'commissions.fa1ePrice.10h.week.total.header': 'Total fee/10h/week/FA1E (7 days)',
  'commissions.fa1ePrice.15h.week.total.header': 'Total fee/15h/week/FA1E (7 days)',
  'commissions.fa2ePrice.header': 'Fee per night FA2E',
  'commissions.fa2ePrice.per.week.header': 'Total fee/week FA2E (7 nights)',
  'commissions.ol.fees.per.fa2ePrice.header': 'LO Fee per FA2E (French students and leaders)',
  'commissions.fa2ePrice.10h.week.total.header': 'Total fee/10h/week/FA2E (7 days)',
  'commissions.fa2ePrice.15h.week.total.header': 'Total fee/15h/week/FA2E (7 days)',
  'commissions.visitPackPrice.header': 'Weekly visit pack supplement (OTO)',
  'commissions.currency.header': 'Currency',
  'commissions.price.header': 'Price',
  'commissions.otoPerHourPrice.header': 'Fee/tuition hour (OTO)',
  'commissions.otoPerHourPrice.per.week.header': 'Weekly visit pack supplement (OTO)',
  'commissions.periods.header': 'Periods',
  'commissions.family.arrangement.header': 'Hosting Options',
  'commissions.providers.header': 'Providers',
  'commissions.applied.durations.in.days.header': 'Duration of stay (# of nights)',
  'commissions.categories.header': 'Categories',
  'commissions.filters.year': 'Year',
  'commissions.filters.products': 'Programs',
  'commissions.filters.formulas': 'Formulas',
  'commissions.filters.durations.in.days': 'Durations (nights)',
  'commissions.filters.periods': 'Period(s)',
  'commissions.filters.family.arrangement': 'Hosting Options',
  'commissions.advancePayment.header': 'Advance Payment',
  'commissions.retainer.header': 'Retainer',
  'commissions.adminFeePerStudent.header': 'Admin Fee per student',
  'commissions.tuitionAndActivity.header': 'Tuition and Activity /day ',
  'commissions.tuitionOnly.header': 'Tuition Only /day ',
  'commissions.activityOnly.header': 'Activity Only /day ',
  'commissions.fullDayOuting.header': 'Full Day Outing',

  //words ----------------------------------------------------------------
  to: 'to',

  //Activity Table ----------------------------------------------------------------
  'activity.table.name': 'Activity Name',
  'activity.table.address': 'Address',
  'activity.table.activitySplitAge': 'Split Age (Activity)',
  'activity.table.leaderFreeRatio': 'Leader Free Ratio',
  'activity.table.comments': 'Comments',
  'activity.table.transportSplitAge': 'Split Age (Transport)',
  'activity.table.transportMode': 'Transport',
  'activity.table.ChildCost': 'Child Cost',
  'activity.table.AdultCost': 'Adult Cost',
  'activity.table.LeaderCost': 'Leader Cost',
  'activity.table.FlatGroupCost': 'Fixed group cost',

  //Mobile Number For French Leaders Table ----------------------------------------------------------------
  'mobile.number.for.french.leaders.table.phoneNumber': 'Mobile number',

  //Coach Company Table ----------------------------------------------------------------
  'coach.company.table.name': 'Name',
  'coach.company.table.phoneNumber': 'Phone number',
  'coach.company.table.comments': 'Comments',
  'coach.company.table.add.coach.company': 'Add coach company',
  'coach.company.created.successfully': 'Coach company created successfully',
  'coach.company.assigned.successfully': 'Coach company assigned successfully.',
  'coach.company.form.name': 'Name',
  'coach.company.form.phone.number': 'Phone number',
  'coach.company.form.emergency.number': 'Emergency number',
  'coach.company.form.address1': 'Address',
  'coach.company.form.address2': 'Address complement',
  'coach.company.form.city': 'Town',
  'coach.company.form.zip.code': 'Zip code',
  'coach.company.form.country': 'Country',
  'coach.company.form.comments': 'Comments',

  //Ol Center Table ----------------------------------------------------------------
  'ol.center.table.header.name': 'Name of the center',
  'ol.center.table.header.date': 'Dates of stay',
  'ol.center.table.header.product.type': 'Type',
  'ol.center.table.students': '# Students',
  'ol.center.table.french.leaders': '# French leaders',
  'ol.center.table.placed.students': '# Students placed',
  'ol.center.table.unplaced.students': '# Students unplaced',
  'ol.center.table.placed.staffs': '# French leaders placed',
  'ol.center.table.unplaced.staffs': '# French leaders unplaced',
  'ol.center.table.affected.students': '# Students affected',
  'ol.center.table.affected.staffs': '# French leaders affected',
  'ol.center.table.students.already.distributed.to.presta':
    '# Students already distributed to presta',
  'ol.center.table.distribution.of.client.information': 'Distribution of client information',
  'ol.center.table.advance.money.transfer': 'Advance money transfer',
  'ol.center.table.before.stay.money.transfer': 'Before stay money transfer',
  'ol.center.table.balance.money.transfer': 'Balance money transfer',
  'ol.center.table.update.status': 'Update status',
  'ol.center.table.travel.info': 'Travel info',
  'ol.center.table.travel.transfer.details': 'Transfer details',
  'ol.center.table.activity.program': 'Activity program',
  'ol.center.table.cost.of.center': 'Cost of center',
  'ol.center.table.teaching.hall': 'Teaching hall',
  'ol.center.table.final.cost': 'Final cost',
  'ol.center.table.students.evaluation': 'Students end of stay evaluation',
  'ol.center.table.students.evaluation.pending': 'To be completed by the OL',
  'ol.center.table.host.family.diffused': 'All information has been shared with parents',
  'ol.center.table.host.family.not.diffused': 'Information to be shared with parents',
  'ol.center.table.travel.info.diffused': 'Travel info received',
  'ol.center.table.travel.info.first.diffusion.pending': 'First diffusion not done yet',
  'ol.center.table.travel.info.not.diffused': 'Change in the travel info',
  'ol.center.table.travel.info.new.diffusion': 'New travel info to check',
  'ol.center.table.travel.info.not.defined': 'Not available yet',
  'ol.center.table.mobile.number.for.FL': 'Mobile number for FL',
  'ol.center.table.mobile.number.for.FL.allocated.tooltip': 'Allocated',
  'ol.center.table.mobile.number.for.FL.to.allocate.tooltip': 'To allocate',
  'ol.center.table.teaching.hall.assign.tooltip': 'Assigned',
  'ol.center.table.teaching.hall.to.assign.tooltip': 'To assign',

  // Center OL Payments ----------------------------------------------------------------
  'center.costs.ol.payments.title': 'Payments',
  'center.costs.ol.payments.advanced.payment': 'Advance payment',
  'center.costs.ol.payments.balance.transfer': 'Balance transfer',
  'center.costs.ol.payments.advance.amount': 'Advance amount:',
  'center.costs.ol.payments.column.date': 'Date',
  'center.costs.ol.payments.column.type': 'Type',
  'center.costs.ol.payments.column.amount': 'Amount',
  'center.costs.ol.payments.column.status': 'Status',

  'center.costs.missing.invoices.title': 'Please upload the missing invoice(s)',
  'center.costs.missing.invoices.for': 'For “{{title}}” {{key}}',

  // Cost Missing Invoices
  'center.costs.missing.invoices.exceptional.expenses': 'Expenses',
  'center.costs.missing.invoices.activities': 'Activities',
  'center.costs.missing.invoices.transfers': 'Transfers',
  'center.costs.missing.invoices.cultural.outings': 'Cultural Outings',
  'center.costs.missing.invoices.teaching.hall.costs': 'Teaching Hall Costs',
  'center.costs.missing.invoices.tefl.costs': 'TEFL Costs',

  // Editable Table Tooltip ----------------------------------------------------------------
  'editableTable.tooltip.initialValue': 'Initial',
  'editableTable.tooltip.olValue': 'Provider',

  // Center Costs Table ----------------------------------------------------------------
  'center.costs.cost.of.center': 'Money transfers',
  'center.costs.cost.of.center.and.money.transfers': 'Cost of center & money transfers',
  'center.costs.synchronize.costs': 'Synchronize',
  'center.costs.synchronize.costs.validation.title':
    'Are you sure you want to restore the parameters initially entered in the tables (LEC local organiser fees, host family prices, TEFL, teaching halls…)? The changes made by hand in the cost of center will be lost.',
  'center.costs.synchronize.costs.validation.confirm': 'Synchronize',
  'center.costs.synchronize.costs.validation.cancel': 'Cancel',
  'center.costs.print.costs': 'Print',
  'center.costs.validate': 'Validate',
  'center.costs.unvalidate': 'Un block',
  'center.costs.reopen': 'Reopen to the provider',
  'center.costs.upload.invoice': 'Upload invoice',

  // Final Balance
  'center.costs.final.balance.title.final.balance': 'Final balance',
  'center.costs.final.balance.total.amounts.previously.transferred':
    'Total amounts previously transferred',
  'center.costs.final.balance.total.final.amount': 'Total final amount',
  'center.costs.final.balance.total.balance': 'Total Balance *',
  'center.costs.final.balance.note':
    '*If the amount is owed to LEC, it will be displayed in green. If the amount is owed to LO, it will be displayed in red',
  'center.costs.final.balance.confirmational.message':
    'I confirm that I have paid all the amounts detailed on this form relating to this language course.',
  'center.costs.final.balance.signed.on': 'Signé le',
  'center.costs.final.send.to.lec': 'Send to LEC',
  'center.costs.final.unlock': 'Débloquer',
  'center.costs.final.final.transfer.cost': 'Virement final cost',
  'center.costs.final.validate': 'Valider',

  //Local Organisers
  'center.costs.local.organisers.fees.title': "Local organiser's fees per student & leaders",
  'center.costs.local.organisers.fees.table.header.pax': 'Pax',
  'center.costs.local.organisers.fees.table.header.fees': 'Fees',
  'center.costs.local.organisers.fees.table.header.total.cost': 'Total cost',
  'center.costs.local.organisers.fees.table.footer.total.fees': 'Total fees',

  // Host Family
  'center.costs.host.family.title': 'Host family',
  'center.costs.host.family.table.header.pax': 'Pax',
  'center.costs.host.family.table.header.cost.per.night': 'Cost / Night',
  'center.costs.host.family.table.header.cost.per.host.family': 'Cost / HF',
  'center.costs.host.family.table.header.cost.tuition.per.week': 'Cost tuition /week',
  'center.costs.host.family.table.header.cost.supply.visits.per.week': 'Suppl visits/week',
  'center.costs.host.family.table.header.total.cost': 'Total cost',
  'center.costs.host.family.table.footer.total.host.family': 'Total HF',

  // TEFL teachers & leaders
  'center.costs.tefl.teachers.and.leaders.title': 'TEFL teachers & leaders',
  'center.costs.tefl.teachers.and.leaders.table.header.number.of.tefl': '# TEFL',
  'center.costs.tefl.teachers.and.leaders.table.header.number.of.days': '# Days',
  'center.costs.tefl.teachers.and.leaders.table.header.cost.per.day': 'Cost/day',
  'center.costs.tefl.teachers.and.leaders.table.header.cost.per.tefl': 'Cost/TEFL',
  'center.costs.tefl.teachers.and.leaders.table.header.cost.total': 'Total cost',
  'center.costs.tefl.teachers.and.leaders.table.footer.total.host.family':
    'Total local teachers/leaders',

  // Teaching hall
  'center.costs.teaching.hall.title': 'Teaching hall',
  'center.costs.teaching.hall.table.add.a.teaching.hall': 'Add a teaching hall',
  'center.costs.teaching.hall.table.header.number.of.classrooms': '# Rooms',
  'center.costs.teaching.hall.table.header.hours.per.classroom': 'Hrs/Day',
  'center.costs.teaching.hall.table.header.number.of.days': '# Days',
  'center.costs.teaching.hall.table.header.cost.per.day': 'Cost per day',
  'center.costs.teaching.hall.table.header.fixed.cost': 'Fixed cost',
  'center.costs.teaching.hall.table.header.total.cost': 'Total costs',
  'center.costs.teaching.hall.table.footer.total.teaching.hall': 'Total Teaching hall',

  // Detailed Activities Table ----------------------------------------------------------------
  'center.costs.detailed.activities.table.group.title.activity.cost': 'Activity cost',
  'center.costs.detailed.activities.table.group.title.french.leader.admin.expenses':
    'French leader admin expenses',
  'center.costs.detailed.activities.table.group.title.local.transport.ftr.and.french.leaders':
    'Local transport (FTR & French leaders)',
  'center.costs.detailed.activities.table.header.programmes': 'Programmes',
  'center.costs.detailed.activities.table.header.number.of.students': '# of students',
  'center.costs.detailed.activities.table.header.number.of.staffs': '# of staffs',
  'center.costs.detailed.activities.table.header.average.cost.per.student':
    'Average cost per student',
  'center.costs.detailed.activities.table.header.total.cost': 'Total cost',
  'center.costs.detailed.activities.table.header.cost.per.student': 'Cost per student',
  'center.costs.detailed.activities.table.header.number.of.students.ftr.and.french.leaders':
    '# of students (FTR) & French leaders',
  'center.costs.detailed.activities.table.header.local.transport.ftr.and.french.leaders':
    'Local transport (FTR & French leaders)',
  'center.costs.detailed.activities.table.header.activity.cost': 'Activity cost',
  'center.costs.detailed.activities.table.header.french.leader.admin.expenses':
    'French leader admin expenses',
  'center.costs.detailed.activities.table.total.budget.of.the.center':
    'Total Budget of the center',

  // Cultural outings
  'center.costs.cultural.outings.title':
    'Cultural outings / activity transportation (coaches booked)',
  'center.costs.cultural.outings.table.header.cultural.outings': 'Cultural Outing/Activity',
  'center.costs.cultural.outings.table.header.cultural.outings.label': 'Cultural Outing/Activity',
  'center.costs.cultural.outings.table.header.total.cost': 'Total cost',
  'center.costs.cultural.outings.table.footer.total.total.transportation.coaches.booked':
    'Total Transportation (coaches booked)',

  // Arrival/Departure Transfers
  'center.costs.arrival.departure.transfers.title': 'Arrival/Departure Transfers',
  'center.costs.arrival.departure.transfers.table.header.from.to': 'From/ To',
  'center.costs.arrival.departure.transfers.table.header.quotation': 'Quotation',
  'center.costs.arrival.departure.transfers.table.header.quotation.label': 'Quotation',
  'center.costs.arrival.departure.transfers.table.header.total.cost': 'Total costs',
  'center.costs.arrival.departure.transfers.table.footer.total.transfers.cost':
    'Total transfer cost',

  // Budget given to the French leader
  'center.costs.french.leader.budget.title': 'Budget given to the French leader',
  'center.costs.french.leader.budget.details.title': 'Budget details',
  'center.costs.french.leader.budget.table.header.activity.budget.paid.by.french.leader':
    'Activity budget paid by the FL',
  'center.costs.french.leader.budget.table.header.admin.expenses': 'Admin expenses',
  'center.costs.french.leader.budget.table.header.total.costs': 'Total costs',
  'center.costs.french.leader.budget.table.header.total.activity.budget': 'Admin expenses',
  'center.costs.tefl.teachers.and.leaders.table.header.upload.invoices': 'Upload invoices',
  'center.costs.tefl.teachers.and.leaders.table.header.upload.receipts': 'Upload receipt',
  'center.costs.french.leader.budget.table.header.french.leaders.local.transport':
    'Local Transport (FTR & French leaders)',
  'center.costs.french.leader.budget.table.footer.label':
    'Total budget given to the French leader',
  'center.costs.french.leader.budget.upload.invoice':
    'Upload the receipt for the budget of the center',

  // Activity budget paid by local organiser
  'center.costs.activity.budget.title': 'Activity budget paid by local organiser',
  'center.costs.activity.budget.table.header.activities': 'Activities',
  'center.costs.activity.budget.table.header.total.cost': 'Total cost',
  'center.costs.activity.budget.table.footer.total.activity.budget.paid.by.local.organiser':
    'Total activity budget paid by local organiser',

  // Miscellaneous
  'center.costs.miscellaneous.title': 'Miscellaneous',
  'center.costs.miscellaneous.table.header.reason': 'Reason',
  'center.costs.miscellaneous.table.header.amount': 'Amount',
  'center.costs.miscellaneous.table.button.add.miscellaneous': 'Add miscellaneous',
  'center.costs.miscellaneous.table.footer.total.miscellaneous': 'Total miscellaneous',

  // Center Total Costs Table ----------------------------------------------------------------
  'center.costs.totals.grand.total': 'Grand total',
  'center.costs.balance': 'Balance',

  // Center Costs Status ----------------------------------------------------------------
  'center.costs.status.send.to.lec': 'Send to LEC',
  'center.costs.status.sent.to.lec.on': 'Cost of center sent to LEC on',

  // Center Final Costs ----------------------------------------------------------------
  'center.final.costs.title': 'Final cost',
  'center.final.costs.instructions.title': 'Final Cost Form - Instructions',
  'center.final.costs.instructions.number.of.students.and.leaders':
    'The number of students & leaders (single/double placements) is automatically calculated based on the actual host family placements.',
  'center.final.costs.instructions.fields.highlighted.in.red':
    'Fields highlighted in red indicate differences from the initial "Cost of Centre" data. Hovering over these fields will display the previous values for comparison.',
  'center.final.costs.instructions.you.can.edit.fields':
    'You can edit any fields that were originally filled in the "Cost of Centre" by clicking directly into the corresponding box.',
  'center.final.costs.instructions.it.is.essential.to.upload.all.invoices':
    'It is essential to upload all invoices to justify the reported costs. Please ensure that the total amount on each invoice matches the amount stated in this final cost.',
  'center.costs.save': 'Save',

  // Center Final Costs Print ----------------------------------------------------------------
  'center.final.costs.print.final.costs': 'Imprimer le final cost',
  'center.final.costs.fees': 'Total Fees',
  'center.final.costs.footer.initial.amaount': 'Initial Amount',
  'center.final.costs.footer.final.amount': 'Final amount',
  'center.final.costs.footer.balance': 'Balance',

  //ol center journey badge ----------------------------------------------------------------
  'ol.center.journey.badge.title': 'Stays',

  //ol center capsule tabs ----------------------------------------------------------------
  'ol.center.capsule.tabs.placement.and.diffusion': 'Students & HF placements',
  'ol.center.capsule.tabs.placement.and.diffusion.residence': 'Students & Leaders info',
  'ol.center.capsule.tabs.center.groups': 'Sub-groups',
  'ol.center.capsule.tabs.cost.of.center': 'Cost of center & money transfers',
  'ol.center.capsule.tabs.simple.cost.of.center': 'Money transfers',
  'ol.center.capsule.tabs.program.and.activities':
    'Activity programme & budget & TEFL & Teaching Hall',
  'ol.center.capsule.tabs.simple.program.and.center.address': 'Activity program & Center address',
  'ol.center.capsule.tabs.simple.program.and.teaching.hall': 'Activity program & Teaching Hall',
  'ol.center.capsule.tabs.travel.info': 'Travel info',
  'ol.center.capsule.tabs.final.cost': 'Final cost',
  'ol.center.capsule.tabs.events': 'Student end of stay evaluation',
  'ol.center.capsule.tabs.end.of.stay.appreciations': 'Youth ratings',
  'center.end.of.stay.appreciations.received': '{{received}}/{{enrolled}} questionnaires received',
  'center.end.of.stay.appreciations.title': 'Youth ratings',
  'center.end.of.stay.appreciations.export': 'Export the ratings to Excel',
  'center.end.of.stay.appreciations.response.rate': '% answered',
  'center.end.of.stay.appreciations.average': 'Average',
  'center.end.of.stay.appreciations.columns.youths': 'Youths',
  'center.end.of.stay.appreciations.columns.last.name': 'LAST NAME',
  'center.end.of.stay.appreciations.columns.first.name': 'First name',
  'center.end.of.stay.appreciations.columns.age': 'Age',
  'center.end.of.stay.appreciations.columns.gender': 'Gender',
  'center.end.of.stay.appreciations.columns.questions': 'Questions',
  'ol.center.end.of.stay.appreciations.diffused.success':
    'The end-of-stay ratings have been shared with the provider.',

  //ol center enrollment table columns ----------------------------------------------------------------
  'ol.center.enrollment.table.columns.student.placed': 'Student placed',
  'ol.center.enrollment.table.columns.diffusion.date.parents': 'Diffusion date to parents',
  'ol.center.enrollment.table.columns.host.family': 'Host family',
  'ol.center.enrollment.table.columns.familyArrangement': 'Accommodation choice',
  'ol.center.enrollment.table.familyArrangement.FA1E': '1 French student per family',
  'ol.center.enrollment.table.familyArrangement.FA2E': '2 French students per family',
  'ol.center.enrollment.table.columns.lastName': "Student's last name",
  'ol.center.enrollment.table.columns.firstName': "Student's first name",
  'ol.center.enrollment.table.columns.host.family.info.sent.to.parents':
    'HF info sent by LEC to the parents',
  'ol.center.enrollment.table.columns.host.family.info.sent.by.lec.to.the.parents':
    'Info sent by LEC to the parents',
  'ol.center.enrollment.table.columns.age': 'Age',
  'ol.center.enrollment.table.columns.classLevel': 'Class level',
  'ol.center.enrollment.table.columns.gender': 'Sex',
  'ol.center.enrollment.table.columns.medicalStatus': 'Health',
  'ol.center.enrollment.table.columns.friends': 'Friends',
  'ol.center.enrollment.table.columns.center.group': 'Sub-group',
  'ol.center.enrollment.table.columns.journeys': 'Program',
  'ol.center.enrollment.table.columns.diffusion.date.presta':
    'Date student info received from LEC',
  'ol.center.enrollment.table.columns.option': 'Option',
  'ol.center.enrollment.table.columns.acknowledgement': 'Acknowledge withdrawal',

  //ol center enrollment table actions ----------------------------------------------------------------
  'ol.center.enrollment.table.actions.email.student.info.to.HF': 'Email student info to the HF',
  'ol.center.enrollment.table.actions.download.id.picture': 'Download ID pictures',
  'ol.center.enrollment.table.actions.print.placement.test.results': 'Download test results',
  'ol.center.enrollment.table.actions.print.detailed.test.results': 'Print detailed test results',
  'ol.center.enrollment.table.actions.download.roaster.list': 'Download roster list',
  'ol.center.enrollment.table.actions.print.my.placement.list.by.name.of.student':
    'Print my placement list by student name',
  'ol.center.enrollment.table.actions.print.my.placement.list.by.name.of.FH':
    'Print my placement list by HF name',
  'ol.center.enrollment.table.actions.print.my.student.list.with.health.problem':
    'Print my student list with health problem',

  //ol center ----------------------------------------------------------------
  'ol.center.back.button': 'back to the list of centers',
  'ol.center.prestataire': 'Contact in Paris',
  'ol.center.lec.phone.number': 'LEC phone number',
  'ol.center.print.the.students.list': 'Print the students list',
  'ol.center.print.global.list': 'Print a global list',
  'ol.center.print.list.by.proram': 'Print list by program',
  'ol.center.print.list.by.sub.group': 'Print list by sub group',
  'ol.center.print.list.by.transport.type': 'Print list by transport type',
  'ol.center.print.enrollments.pickup.list': 'Designated pickup person list - individual trips',
  'ol.center.placement.diffusion.title': 'Students & HF placements',
  'ol.center.placement.diffusion.title.residence': 'Students & Leaders info',
  'ol.center.placement.diffusion.phone.number': 'Mobile number for French leaders',
  'ol.center.staff.table.title': 'List of the LEC leaders',
  'ol.center.staff.table.diffusion.button': 'Diffusion to parents',
  'ol.center.enrollment.table.title': 'List of students',
  'ol.center.enrollment.table.diffusion.button': 'Diffusion to parents',
  'ol.center.enrollment.table.print.by.name.of.student.button':
    'Print my placement list by student name',
  'ol.center.enrollment.table.print.by.name.of.FH.button': 'Print my placement list by HF name',
  'ol.center.enrollment.table.comment.title': 'Comments',
  'ol.center.assign.host.family': 'Assign Host Family',
  'ol.center.assign.new.host.family.to.staff': 'Assign a new Host Family',

  //Teaching Hall Table ----------------------------------------------------------------
  'teaching.hall.table.name': 'Name',
  'teaching.hall.table.address': 'Address',
  'teaching.hall.table.number.of.classrooms': '# of classrooms',
  'teaching.hall.table.contact': 'Contact',
  'teaching.hall.table.phoneNumber': 'Phone number',
  'teaching.hall.success.message': 'Teaching hall successfully updated',

  // affected staffs table ----------------------------------------------------------------
  'affected.staffs.table.firstName': 'First Name',
  'affected.staffs.table.lastName': 'Last Name',
  'affected.staffs.table.qualification': 'Qualification',
  'affected.staffs.table.age': 'Age',
  'affected.staffs.table.gender': 'Sex',
  'affected.staffs.table.accommodation': 'Accommodation',

  'staff.personal.space.students.title': 'Listes des Jeunes',
  'staff.personal.space.students.view.list': 'Vue liste',
  'staff.personal.space.students.view.grid': 'Vue Photo',
  'staff.personal.space.my.journeys.details.students.no.enrollments.permission':
    'The list of the young people in your group will be available online no later than 30 days before your departure. You will receive a notification email as soon as it becomes available.',
  'staff.personal.space.students.table.actions.add.request':
    'Voir les fiches sanitaires de liaisons',
  'staff.personal.space.students.table.actions.print.youth.list': 'Imprimer la liste des jeunes',
  'staff.personal.space.students.table.actions.print': 'Imprimer',
  'staff.personal.space.students.table.actions.print.youth.list.by.level':
    'Print the youth list by level',
  'staff.personal.space.students.table.actions.export.youth.list.to.excel':
    'Exporter la liste des jeunes en Excel',
  'staff.personal.space.students.table.actions.print.youth.list.by.host.family':
    'Print the youth list by host family',
  'staff.personal.space.students.columns.last.name': 'Nom',
  'staff.personal.space.students.columns.first.name': 'Prénom',
  'staff.personal.space.students.columns.medical.status': 'Infos santé',
  'staff.personal.space.students.columns.can.go.out.alone': 'Sorties seul le soir autorisées',
  'staff.personal.space.students.columns.can.not.go.out.alone':
    'Sorties seul le soir non autorisées',
  'staff.personal.space.students.columns.aa': 'AA',
  'staff.personal.space.students.columns.age': 'Age',
  'staff.personal.space.students.columns.gender': 'Sex',
  'staff.personal.space.students.columns.school.level': 'Class',
  'staff.personal.space.students.columns.class.level': 'Test level result',
  'staff.personal.space.students.columns.formula': 'Formula',
  'staff.personal.space.students.columns.theme': 'Theme',
  'staff.personal.space.students.columns.optional.option': 'Optional Option',
  'staff.personal.space.students.columns.main.trip': 'Main Trip',
  'staff.personal.space.students.columns.departure.city': 'Departure City',
  'staff.personal.space.students.columns.parent1.phone.number': 'N° tel parent 1',
  'staff.personal.space.students.columns.parent2.phone.number': 'N° tel parent 2',
  'staff.personal.space.students.columns.student.phone.number': 'Student phone number',
  'staff.personal.space.students.columns.friends': 'Friends',
  'staff.personal.space.students.columns.host.family.name': 'Host Family',
  'staff.personal.space.students.columns.host.family.modal.title': 'Host Family details',
  'staff.personal.space.students.card.parents.contact': 'Parents contacts',
  'staff.personal.space.students.card.emergency.contact': 'Emergency contact',
  'staff.personal.space.students.card.health.info': 'Health info',
  'staff.personal.space.students.card.insurance': 'Repatriation insurance',
  'staff.personal.space.students.card.vaccination': 'Vaccinations',
  'staff.personal.space.students.card.status.loading.enrollments': 'Loading students...',
  'staff.personal.space.students.card.status.error.loading.enrollments': 'Error loading students',
  'staff.personal.space.students.card.status.loading.more.enrollments': 'Loading students...',

  'enrollment.vaccinations.diphtheria': 'Diphtérie',
  'enrollment.vaccinations.tetanus': 'Tétanos',
  'enrollment.vaccinations.poliomyelitis': 'Poliomyélite',
  'enrollment.vaccinations.dtPolioTetracoq': 'OU DT Polio / Tétracoq',
  'enrollment.vaccinations.pertussis': 'Coqueluche',
  'enrollment.vaccinations.hepatitisB': 'Hépatite B',
  'enrollment.vaccinations.rubellaMumpsMeasles': 'Rubéole - Oreillons - Rougeole',
  'enrollment.vaccinations.bcg': 'BCG',
  'enrollment.vaccinations.haemophilus': 'Haemophilus',
  'enrollment.vaccinations.pneumococcus': 'Pneumocoque',
  'enrollment.vaccinations.meningococcusC': 'Méningocoque C',
  'enrollment.vaccinations.otherVaccinations': 'Autres vaccins (préciser)',
  'enrollment.vaccinations.additionalRecommendations': 'Recommandations utiles des parents',

  //ol center tooltip ----------------------------------------------------------------
  'ol.center.tooltip.canGoOutAlone': 'Allowed to go out alone in the evening, max 10pm',
  'no.ol': 'No OL found',

  //ol center host family placement history ----------------------------------------------------------------
  'ol.center.host.family.placement.history.title': 'Placement History',
  'ol.center.host.family.placement.history.hostFamily.name': 'Host Family Name',
  'ol.center.host.family.placement.history.reason': 'Reason for Change',
  'ol.center.host.family.mixed.gender.title': 'Boy and girl in the same host family',
  'ol.center.host.family.reason.for.change.required': 'Please enter the reason for the change',

  //ol center placement badges  ----------------------------------------------------------------
  'ol.center.placement.badge.students.in.center.title': 'Students in the center',
  'ol.center.placement.badge.staffs.in.center.title': 'LEC leaders in the center',
  'ol.center.placement.badge.placed': 'placed',
  'ol.center.placement.badge.not.placed': 'unplaced',

  // ol center placement diffusion success message ----------------------------------------------------------------
  'ol.center.placement.diffusion.host.family.success':
    'Host family successfully diffused to parents.',
  'ol.center.placement.diffusion.center.manager.success':
    'Center manager successfully diffused to parents.',

  //ol center placement change french leader phone number ----------------------------------------------------------------
  'ol.center.placement.change.french.leader.phone.number':
    'Add a mobile phone number for the French leader',

  //ol center placement change host family ----------------------------------------------------------------
  'ol.center.placement.change.host.family': 'Assign a teaching hall',
  'ol.center.placement.change.host.family.label': 'Assign teaching hall',

  //ol center trips info ----------------------------------------------------------------
  'ol.center.trips.info.warning.note':
    'Warning: some information has been modified since the last diffusion.',
  'ol.center.trips.info.title': 'Travel info',
  'ol.center.trips.info.date.of.diffusion': 'Date of diffusion',
  'ol.center.trips.info.login.user': 'Login user',
  'ol.center.trips.info.time.note': 'All times are given in local time',
  'ol.center.trips.info.diffuse.travel.info': 'Diffusion of travel information to parents',
  'ol.center.trip.booking.success.message': 'trip successfully diffused to parents',
  'ol.center.trip.booking.not.diffused.title': 'Travel info not sent',
  'ol.center.trip.booking.not.diffused.message.single':
    'Travel info not emailed to the provider of this center:',
  'ol.center.trip.booking.not.diffused.message.multiple':
    'Travel info not emailed to the providers of these centers:',
  'ol.center.trip.booking.data.has.not.been.loaded': 'This information is not available yet.',
  'ol.center.trip.booking.local.coach.company': 'Local coach company',
  'ol.center.trip.booking.coach.company.name': 'Coach company',
  'ol.center.trip.booking.coach.company.phone.number': 'Coach company phone number',
  'ol.center.trip.booking.coach.company.emergency.number': 'Coach company emergency number',
  'ol.center.trip.booking.arrival.day': 'Arrival Day',
  'ol.center.trip.booking.departure.day': 'Departure day',
  'ol.center.trip.booking.no.coach.company.available':
    'No coach companies available, Please add a coach company.',

  //ol center trip booking details ----------------------------------------------------------------
  'ol.center.trip.booking.details.departure.date': 'Departure Date',
  'ol.center.trip.booking.details.departure.location': 'Departure Location',
  'ol.center.trip.booking.details.departure.time': 'Departure Time',
  'ol.center.trip.booking.details.arrival.date': 'Arrival Date',
  'ol.center.trip.booking.details.arrival.location': 'Arrival Location',
  'ol.center.trip.booking.details.arrival.time': 'Arrival Time',
  'ol.center.trip.booking.details.transport.company': 'Transport Company',
  'ol.center.trip.booking.details.transport': 'Transport',
  'ol.center.trip.booking.details.flight.train.number': 'Flight/Train Number',
  'ol.center.trip.booking.details.meeting.place.for.company':
    'Meeting place for the coach company',
  'ol.center.trip.booking.details.drop.off.point.for.company':
    'Drop-off point of the group by the coach company',
  'ol.center.trip.booking.details.drop.off.time.for.company':
    'Drop-off time of the group by the coach company',
  'ol.center.trip.booking.details.meeting.time.for.company': 'Meeting time for the coach company',
  'ol.center.trip.booking.aller.details.instructions.drop.off.for.company':
    'Instructions for the Local Organiser',
  'ol.center.trip.booking.retour.details.instructions.drop.off.for.company':
    'Instructions for the Local Organiser',
  'ol.center.trip.booking.details.instructions.for.company':
    'Instructions for the Local Organiser',

  //ol center program and activities ----------------------------------------------------------------
  'ol.center.program.activities.title': 'Activity programme & budget - TEFL & Teaching Hall',
  'center.costs.program.documents.title': 'Program Details',
  'center.costs.program.documents.upload': 'Upload program',
  'center.costs.program.no.documents.uploaded': 'No documents uploaded',
  'center.costs.address.title': 'Center Address',
  'center.costs.address.name': 'Name',
  'center.costs.address.address': 'Address',
  'center.costs.address.no.data': 'No data available',
  'center.costs.address.course.location': 'Place of tuition (if different)',
  'center.costs.address.course.address': 'Address of tuition (if different)',
  'ol.center.program.activities.planner.title': 'Program details',
  'ol.center.program.activities.planner.arival': 'Arrival',
  'ol.center.program.activities.planner.departure': 'Departure',
  'ol.center.program.activities.activity.table.title': 'Activities',
  'ol.center.program.activities.local.transport.table.title': 'Local transport',
  'ol.center.program.activities.tefl.table.name': 'TEFL',
  'ol.center.program.activities.tefl.not.assigned': 'Not assigned',
  'ol.center.program.activities.teaching.hall.table.name': 'Teaching Hall',
  'ol.center.program.activities.timezone':
    'Note: All displayed times are in the {{timezone}} timezone',
  'ol.center.program.activities.add.course': 'Add Course',
  'ol.center.program.activities.sent.to.lec.badge': 'The Activity programme has been sent to LEC',
  'ol.center.program.activities.print.program': 'Print the program',
  'ol.center.program.activities.print.program.by.price': 'Print the programme with prices',
  'ol.center.program.activities.add.activity': 'Add Activity',
  'ol.center.program.activities.print.level.tests': 'Print level tests',
  'ol.center.program.activities.print.level.tests.results': 'Print level tests results',
  'ol.center.program.activities.planner.course': 'Course',
  'ol.center.program.activities.planner.activity.form.create.title': 'Add an activity',
  'ol.center.program.activities.planner.activity.form.date': 'date',
  'ol.center.program.activities.planner.activity.form.starting.time': 'starting time',
  'ol.center.program.activities.planner.activity.form.ending.time': 'ending time',
  'ol.center.program.activities.planner.activity.form.activity.id': 'activity',
  'ol.center.program.activities.planner.activity.form.comment': 'comment',
  'ol.center.program.activities.planner.activity.form.activity.paid.by': 'activity paid by',
  'ol.center.program.activities.planner.activity.form.journey.ids': 'Please choose a journey',
  'ol.center.program.activities.planner.activity.form.error.starting.time':
    'The starting time must be before the ending time.',
  'ol.center.program.activities.planner.activity.form.date.label': 'Date',
  'ol.center.program.activities.planner.activity.form.starting.time.label':
    'Beginning of the activity',
  'ol.center.program.activities.planner.activity.form.ending.time.label': 'End of the activity',
  'ol.center.program.activities.planner.activity.form.activity.id.label': 'Activity',
  'ol.center.program.activities.planner.activity.form.comment.label': 'Comment',
  'ol.center.program.activities.planner.activity.form.activity.paid.by.label': 'Activity paid by',
  'ol.center.program.activities.planner.activity.form.journey.ids.label':
    'Select the programmes concerned by this activity',
  'ol.center.program.activities.planner.activity.form.journey.ids.not.available':
    'No journeys available',
  'ol.center.program.activities.planner.activity.form.option.id.label':
    'Students concerned by this activity',
  'ol.center.program.activities.planner.activity.form.option.id.none':
    'All the students of the selected programmes',
  'ol.center.program.activities.planner.activity.form.option.id.option':
    'Only the students who booked the option "{{option}}"',
  'ol.center.program.activities.planner.activity.form.comment.add': 'Add comment',
  'ol.center.program.activities.planner.activity.form.comment.placeholder':
    'Note any useful information here, such as “arrive 15 minutes before the activity starts,” “bring a towel and sun cream,” etc.',
  'ol.center.program.activities.planner.activity.form.edit.title': 'Edit an activity',
  'ol.center.program.activities.planner.activity.form.delete.title':
    'Remove the activity from the program',
  'ol.center.program.activities.planner.course.form.create.title': 'Add course',
  'ol.center.program.activities.planner.activity.create.success.message':
    'Activity created successfully',
  'ol.center.program.activities.planner.activity.edit.success.message':
    'Activity updated successfully',
  'ol.center.program.activities.planner.activity.delete.success.message':
    'Activity deleted successfully',
  'ol.center.program.activities.planner.course.create.success.message':
    'Course created successfully',
  'ol.center.program.activities.planner.open.activity.success.message':
    'Activity successfully opened',
  'ol.center.program.activities.planner.send.activity.success.message':
    'Activity successfully sent to LEC',
  'ol.center.program.activities.planner.validate.activity.success.message':
    'Activity successfully validated',
  'ol.center.program.activities.planner.break.included': 'Break included',

  //ol center program course form ----------------------------------------------------------------
  'ol.center.program.course.form.update.title': 'Update Course',
  'ol.center.program.course.form.date': 'Date',
  'ol.center.program.course.form.start.time': 'Start Time',
  'ol.center.program.course.form.end.time': 'End Time',
  'ol.center.program.course.form.delete.button': 'Delete Course',
  'ol.center.program.course.form.delete.success.message': 'Course successfully deleted',
  'ol.center.program.course.form.edit.success.message': 'Course successfully updated',

  //ol center program activities table ----------------------------------------------------------------
  'ol.center.program.activities.table.title': 'Activities',
  'ol.center.program.activities.table.name': 'Activity',
  'ol.center.program.activities.table.number.of.students': '# Students',
  'ol.center.program.activities.table.number.of.leaders': '# Leaders',
  'ol.center.program.activities.table.local.transport': 'Local transport',
  'ol.center.program.activities.table.average.cost.per.student': 'Average cost per student',
  'ol.center.program.activities.table.total.cost': 'Total cost (transport excluded)',
  'ol.center.program.activities.table.paid.by': 'Paid by',
  'ol.center.program.activities.table.programs': 'Programs',
  'ol.center.program.activities.table.option': 'Option',
  'ol.center.program.activities.table.total.activity.cost': 'Total activity cost',
  'ol.center.program.activities.table.part.paid.by.local.organizer':
    'Part paid by Local Organiser',
  'ol.center.program.activities.table.part.paid.by.french.leader': 'Part paid by French Leader',

  //ol center local transport table ----------------------------------------------------------------
  'ol.center.local.transport.table.title': 'Local transport',
  'ol.center.local.transport.table.split.age': 'Split Age',
  'ol.center.local.transport.table.price': 'Price',
  'ol.center.local.transport.table.ftr.students': '# FTR students',
  'ol.center.local.transport.table.ftr.amount': 'FTR amount',
  'ol.center.local.transport.table.french.leaders': ' Leaders',
  'ol.center.local.transport.table.french.leaders.amount': 'Leader amount',
  'ol.center.local.transport.table.total.cost': 'Total cost',
  'ol.center.local.transport.table.extra.transport.cost.for.ftr.students':
    'Extra transport cost for FTR students',
  'ol.center.local.transport.table.extra.transport.cost.for.leaders':
    'Extra transport cost for Leaders',
  'ol.center.local.transport.table.total.local.transport.ftr.students.leaders':
    'Total local transport FTR students and leaders ',
  'ol.center.local.transport.table.part.paid.by.french.leader': 'Part paid by French Leader',
  'ol.center.local.transport.table.part.paid.by.local.organizer': 'Part paid by Local Organiser',

  //ol center admin and grand expenses ----------------------------------------------------------------
  'ol.center.admin.expenses.title': 'Admin expenses',
  'ol.center.admin.expenses.total': 'Total admin expenses',
  'ol.center.admin.expenses.paid.by.french.leader': 'Part paid by French Leader',
  'ol.center.admin.expenses.paid.by.local.organizer': 'Part paid by Local Organiser',
  'ol.center.grand.expenses.title': 'Grand Total',
  'ol.center.grand.expenses.total': 'Total',
  'ol.center.grand.expenses.paid.by.french.leader': 'Part paid by French Leader',
  'ol.center.grand.expenses.paid.by.local.organizer': 'Part paid by Local Organiser',

  //ol center Tefl Table ----------------------------------------------------------------
  'ol-center.tefl.table.badge.text': 'TEFLs left to be staffed',
  'ol.center.tefl.table.lastName': 'Last name',
  'ol.center.tefl.table.firstName': 'First name',
  'ol.center.tefl.table.qualification': 'Qualification',
  'ol.center.tefl.table.age': 'Age',
  'ol.center.tefl.table.gender': 'Sex',

  //ol center Teaching hall badge ----------------------------------------------------------------
  'ol.center.teaching.hall.badge.text': 'Teaching hall(s) left',

  //center filters ----------------------------------------------------------------
  'center.filters.country': 'Country',
  'center.filters.periods': 'Period(s)',
  'center.filters.formula': 'Formula(s)',

  //hobbies ----------------------------------------------------------------
  'hobbies.title': 'Hobbies, Interests',
  'hobbies.input.title': 'Hobbies',
  'hobbies.input.other': 'Other',

  //image card -------------------------------------------------------------------
  'image.card.caption.label': 'Caption (in the language of the host country)',
  'image.card.upload.label': 'Upload photo *',
  'image.card.drag.label': 'Drag and drop or browse',

  //host family images ----------------------------------------------------------------
  'host.family.images.note':
    'They should be pleasant: remember that this is the first contact the host family will have with the participant, and the photos should present them in a friendly way. Include pictures of your family in the living room or garden, during a birthday, on vacation, etc. Please provide a caption for each photo (in the language of the host country).',

  //affected staff questionnaire ----------------------------------------------------------------
  'affected.staff.questionnaire.title': 'Supplementary Questionnaire',
  'affected.staff.questionnaire.information.1':
    'This supplementary form must be completed promptly and with as much detail as possible. As long as you have not filled in all the fields and clicked on "',
  'affected.staff.questionnaire.information.2': 'Validate and send to LEC ',
  'affected.staff.questionnaire.information.3':
    '”, we will not be able to select your host family.',

  'affected.staff.questionnaire.personality.title': 'Personality',
  'affected.staff.questionnaire.personality.closer.to': 'Are you more of an',
  'affected.staff.questionnaire.personality.have.religious.affiliation.question':
    'Do you have a religious affiliation you wish to mention?',
  'affected.staff.questionnaire.which.one': 'Which one?',
  'affected.staff.questionnaire.personality.interest': 'Your interests',
  'affected.staff.questionnaire.personality.accept.living.with.family.of.different.ethnic.background.question':
    'Do you accept being hosted by a family of a different ethnic background?',

  'affected.staff.questionnaire.health.information.title': 'Health Information',
  'affected.staff.questionnaire.health.information.are.you.in.good.health':
    'Are you in good health?',
  'affected.staff.questionnaire.health.information.do.you.have.asthma':
    'Are you subject to asthma?',
  'affected.staff.questionnaire.health.information.do.you.have.allergy':
    'Do you have any allergies?',
  'affected.staff.questionnaire.health.information.do.you.smoke': 'Do you smoke?',
  'affected.staff.questionnaire.health.information.agree.to.family.lifestyle':
    'I agree to conform to the family lifestyle and not smoke in front of the young people in the group',
  'affected.staff.questionnaire.health.information.other.information':
    'Other information (in English)',
  'affected.staff.questionnaire.health.information.other.information.placeholder':
    'Other information',
  'affected.staff.questionnaire.health.information.health.note':
    'Please note that LEC cannot guarantee that the dietary requirements or allergies of management staff will be taken into account during stays.',

  'affected.staff.questionnaire.driver.license.title': 'Driver License',
  'affected.staff.questionnaire.driver.license.do.you.have.driver.license':
    'Do you have your driver license?',
  'affected.staff.questionnaire.driver.license.do.you.drive.regularly': 'Do you drive regularly?',
  'affected.staff.questionnaire.driver.license.note':
    "Remember to apply for your international driver's license now.",

  'affected.staff.questionnaire.host.family.letter': 'Letter to your host family',
  'affected.staff.questionnaire.host.family.letter.note':
    'This letter must be written in English. Remember that it will be your very first contact with your host family. Be sure to detail your interests, the sports you practice, etc. Describe your family, specify if you have children, their ages. Talk about your environment, where you live, the region you live in, etc. Explain the reasons why you want to make this stay.',
  'affected.staff.questionnaire.host.family.letter.placeholder': 'Write here',

  'affected.staff.questionnaire.host.family.pictures.title': 'Some photos of your family',
  'affected.staff.questionnaire.host.family.pictures.note.1': 'Please upload:',
  'affected.staff.questionnaire.host.family.pictures.note.2':
    'At least 3 recent photos like those you would find in a family album. ',
  'affected.staff.questionnaire.host.family.pictures.note.3':
    'They should be pleasant: remember that this is the first contact the host family will have with you, and the photos should present you in a friendly way. Include pictures of your family in the living room or garden, during a birthday, on vacation, etc. Please provide a caption for each photo (in English).',
  'affected.staff.questionnaire.host.family.pictures.note.nb': 'NB:',
  'affected.staff.questionnaire.host.family.pictures.note.nb.text':
    'Use JPG or PNG images, smaller than 2 MB',
  'affected.staff.questionnaire.host.family.pictures.upload.label.btn': 'Add photos',

  'affected.staff.questionnaire.medical.release': 'Medical Release',
  'affected.staff.questionnaire.medical.release.note.1': 'I, the undersigned,',
  'affected.staff.questionnaire.medical.release.note.2':
    'authorize LEC, 89 avenue de Villiers, Paris 75017, as well as its collaborators and representatives, both French and foreign (and the host family), to act on my behalf in case of emergency (illness, accident, surgical operation – including anesthesia –, hospitalization) during the duration of my stay abroad. This release will be presented to the physician, dentist, surgeon, or hospital doctor if necessary.',
  'affected.staff.questionnaire.medical.release.checkbox.label': 'I give my authorization',

  'client.child.profile.medical.release.title': 'Medical release',
  'client.child.profile.medical.release.long.text':
    'I, the undersigned, father, mother or guardian of {{childFirstName}} {{childLastName}}, authorize LEC, 89 avenue de Villiers in Paris 75017, as well as its French and foreign collaborators and representatives (and the host family) to act on my behalf in case of emergency (illness, accident, surgical operation - including anesthesia -, hospitalization) during the period of his/her stay abroad. This release will be presented to the doctor, dentist, surgeon or hospital director if necessary.',
  'client.child.profile.medical.release.short.text':
    'In case of an emergency, the parents or legal guardian authorize LEC to take all necessary measures to provide medical care for their child, including, if needed, hospitalization and surgery (including anesthesia).',
  'client.child.profile.medical.release.checkbox.label':
    'I give my authorization (parent, guardian)',

  'client.child.profile.terms.checkbox.label': 'I have read and accept the',
  'client.child.profile.terms.link': 'general terms and conditions of sale',
  'client.child.profile.terms.accepted.label': 'You have accepted the',
  'client.child.profile.terms.required':
    'You must accept the general terms and conditions of sale',

  'affected.staff.questionnaire.drives.regularly': 'Drives regularly',

  'staff.personal.space.save.for.later.btn': 'Save and continue later',
  'staff.personal.space.submit.btn': 'Validate and send to LEC',

  'staff.personal.space.yes': 'Yes',
  'staff.personal.space.no': 'No',

  'questionnaire.toast.success': 'Questionnaire submitted successfully',
  'questionnaire.toast.error.familyImages': 'Please provide valid family images with captions',
  'questionnaire.toast.error.familyImagesMinimum': 'Please upload at least 3 family images',

  //large image error -----------------------------------------------------
  'images.size.error': 'The file must not exceed',
  'images.aspect.ratio.error': 'Please upload an image with an aspect ratio of',
  'images.read.error': 'Unable to read the file.',

  //logout ----------------------------------------------------------------
  logout: 'Log out',

  //editable table -------------------------------------------------------------
  'editable.table.max.value.error': 'The value must not exceed',
  'editable.table.min.value.error': 'The value must be at least',
  'editable.table.select.none': 'None',

  //staff personal space details trip card --------------------------------
  'staff.personal.space.details.trip.card.aller': 'Departure trip',
  'staff.personal.space.details.trip.card.retour': 'Return trip',
  'staff.personal.space.details.trip.card.date.of.departure': 'Departure date',
  'staff.personal.space.details.trip.card.date.of.return': 'Return date',
  'staff.personal.space.details.trip.card.meeting.place': 'Meeting place',
  'staff.personal.space.details.trip.card.place.of.arrival': 'Place of arrival',
  'staff.personal.space.details.trip.card.appointment.time': 'Appointment time',
  'staff.personal.space.details.trip.card.time.of.arrival': 'Time of arrival',

  //magic link -------------------------------------------------------------
  'magic.link.check.inbox': 'Check your inbox',
  'magic.link.text': 'You should receive an email with a magic link to log in.',

  //oto individual places -------------------------------------------------------------
  'oto.individual.title': 'One To One Individuals',
  'oto.individual.periods.table.title': 'All One To One Individuals',
  'oto.individual.periods.placement.info':
    'Total number of students: {{total}} (placed: {{placed}} – unplaced: {{unplaced}})',
  'oto.individual.periods.column.period': 'Period',
  'oto.individual.periods.column.students.placed': '# Students placed',
  'oto.individual.periods.column.students.unplaced': '# Students unplaced',
  'oto.individual.periods.column.students.affected': '# Students assigned',
  'oto.individual.periods.column.students.to.diffuse': '# Students to diffuse to the provider',
  'oto.individual.periods.column.students.diffused': '# Students already diffused to the provider',
  'oto.individual.periods.column.client.info.diffusion': 'HF info sent by LEC to parents',
  'oto.individual.periods.info.some.not.sent': 'Some info not sent',
  'oto.individual.periods.info.no.placements': 'No placed students yet',
  'oto.individual.periods.info.all.sent': 'All info sent',
  'oto.individual.periods.actions.diffuse.to.ol': 'Diffuse students to the provider',
  'oto.individual.periods.actions.diffuse.to.ol.confirm':
    'The youths of the selected periods will be diffused to the provider. Do you want to continue?',
  'oto.individual.periods.diffuse.to.ol.success':
    'The youths have been successfully diffused to the provider.',

  'oto.individual.placements.title': 'One to One Individuel - Students list',
  'oto.individual.placements.period.label': 'Period:',
  'oto.individual.placements.table.title': 'All One to One Individuel students',
  'oto.individual.placements.column.student.placed': 'Student placed',
  'oto.individual.placements.column.last.name': "Student's last name",
  'oto.individual.placements.column.first.name': "Student's first name",
  'oto.individual.placements.column.dates.of.stay': 'Dates of stay',
  'oto.individual.placements.column.weeks': '# of weeks',
  'oto.individual.placements.column.age': 'Age',
  'oto.individual.placements.column.school.level': 'Class',
  'oto.individual.placements.column.sex': 'Sex',
  'oto.individual.placements.column.health': 'Health',
  'oto.individual.placements.column.hours.per.week': 'Hours of tuition/week',
  'oto.individual.placements.column.option': 'Option',
  'oto.individual.placements.column.arrival.location': 'Arrival location',
  'oto.individual.placements.column.area.of.stay': 'Area of stay',
  'oto.individual.placements.column.transfer.welcome': 'Transfer welcome',
  'oto.individual.placements.column.travel.info': 'Travel info',
  'oto.individual.placements.column.host.family': 'Host family',
  'oto.individual.placements.column.hf.info.sent.to.parents': 'HF info sent by LEC to parents',
  'oto.individual.placements.column.parents.diffusion.status': 'Parents diffusion status',
  'oto.individual.placements.column.last.parents.diffusion.date':
    'Date of the last diffusion to parents',
  'oto.individual.placements.column.diffused.to.ol': 'Youth diffusion date to the provider',
  'oto.individual.placements.host.family.info.emailed':
    'Information has been emailed to the host family',
  'oto.individual.placements.host.family.assign': 'Assign a host family',
  'oto.individual.placements.host.family.change': 'Change the host family',
  'oto.individual.placements.host.family.assigned': 'Host family assigned successfully!',
  'oto.individual.placements.host.family.changed': 'Host family changed successfully!',
  'oto.individual.placements.host.family.unassigned': 'Host family unassigned successfully!',
  'oto.individual.placements.removed': '(Removed)',
  'oto.individual.placements.acknowledgement': 'Acknowledge withdrawal',
  'oto.individual.placements.removal.acknowledged': 'Withdrawal acknowledged successfully!',
  'oto.individual.placements.transfer.welcome.yes': 'Yes',
  'oto.individual.placements.filter.country': 'Country',
  'oto.individual.placements.filter.departure.date': 'Departure date',
  'oto.individual.placements.filter.arrival.date': 'Arrival date',
  'oto.individual.placements.period.invalid': 'Invalid period identifier',
  'oto.individual.placements.period.not.found': 'Period not found',
  'oto.individual.placements.info.not.fully.sent.to.parents':
    'HF info has not been fully sent to the parents yet',
  'oto.individual.placements.actions.diffuse.info.to.parents': 'Diffuse info to the parents',
  'oto.individual.placements.actions.send.host.family.info':
    'Send the host family info to the family',
  'oto.individual.placements.actions.print.transfers.list': 'Print my students transfers list',
  'oto.individual.placements.info.sent.success':
    'The host family information has been sent to the families.',
  'oto.individual.placements.enrollments.info.sent.success':
    'The youth information has been sent to the host families.',
  'oto.individual.placements.actions.diffuse.end.of.stay.appreciations':
    'Share end-of-stay ratings',
  'oto.individual.placements.end.of.stay.appreciations.diffused.success':
    'The end-of-stay ratings have been shared with the provider.',
  'oto.individual.placements.transfer.person.title': 'Person in charge of the transfers',
  'oto.individual.placements.transfer.person.last.name': 'Last name',
  'oto.individual.placements.transfer.person.first.name': 'First name',
  'oto.individual.placements.transfer.person.phone.number': 'Phone number',
  'oto.individual.placements.transfer.person.email': 'Email',
  'oto.individual.placements.transfer.person.updated.success':
    'The person in charge of the transfer has been saved.',
  'oto.individual.placements.transfer.person.missing': 'Person in charge missing',
  'oto.individual.placements.transfer.person.completed': 'Completed',
  'oto.individual.placements.travel.info.not.available': 'Not available yet',

  // affected staff evaluations -------------------------------------------------------------
  'affected.staff.evaluations.lec.rating': 'LEC rating',
  'affected.staff.evaluations.comment': 'Comment',
  'affected.staff.evaluations.youths.rating': 'Youths’ average rating',
  'affected.staff.evaluations.youths.rating.answers': '{{answers}} answer(s)',
  'affected.staff.evaluations.youths.rating.not.rated': 'Not rated for this qualification',
  'affected.staff.evaluations.youths.rating.error': 'An error occurred',

  // end of stay appreciations -------------------------------------------------------------
  'enrollment.end.of.stay.appreciations.all.questions': 'All questions',
  'enrollment.end.of.stay.appreciations.no.stay': 'No stay',

  'end.of.stay.appreciations.summary.page.title': 'Ratings',
  'end.of.stay.appreciations.summary.table.title': 'All ratings',
  'end.of.stay.appreciations.summary.total': 'Total: {{total}}',
  'end.of.stay.appreciations.summary.print': 'Print',
  'end.of.stay.appreciations.summary.print.loading': 'Loading…',
  'end.of.stay.appreciations.summary.print.blocked':
    'The print window was blocked by the browser.',
  'end.of.stay.appreciations.summary.export': 'Excel export',
  'end.of.stay.appreciations.summary.filter': 'Filter by',
  'end.of.stay.appreciations.summary.filter.country': 'Country',
  'end.of.stay.appreciations.summary.filter.formula': 'Formula',
  'end.of.stay.appreciations.summary.filter.theme': 'Theme',
  'end.of.stay.appreciations.summary.filter.ol': 'Provider',
  'end.of.stay.appreciations.summary.filter.periods': 'Periods',
  'end.of.stay.appreciations.summary.filter.year': 'Year',
  'end.of.stay.appreciations.summary.filter.include.oto': 'Include OTO',
  'end.of.stay.appreciations.summary.filter.five.stars': 'Ratings out of 5',
  'end.of.stay.appreciations.summary.filter.three.stars': 'Ratings out of 3',
  'end.of.stay.appreciations.summary.filter.star': '{{stars}} star',
  'end.of.stay.appreciations.summary.filter.stars': '{{stars}} stars',
  'end.of.stay.appreciations.summary.filter.scan.status.all': 'All',
  'end.of.stay.appreciations.summary.filter.scan.status.not.scanned': 'Centres not scanned',
  'end.of.stay.appreciations.summary.filter.scan.status.incomplete': 'Incomplete centres',
  'end.of.stay.appreciations.summary.columns.country': 'Country',
  'end.of.stay.appreciations.summary.columns.centre': 'Centre',
  'end.of.stay.appreciations.summary.columns.enrolled': 'enr.',
  'end.of.stay.appreciations.summary.sort.asc': 'Sort ascending',
  'end.of.stay.appreciations.summary.sort.desc': 'Sort descending',
  'end.of.stay.appreciations.summary.general.total': 'GRAND TOTAL',
  'end.of.stay.appreciations.summary.rows.answers': 'Total answers',
  'end.of.stay.appreciations.summary.rows.response.rate': 'Response rate (%)',
  'end.of.stay.appreciations.summary.rows.average': 'Average',
  'end.of.stay.appreciations.summary.rows.enrolled.and.average': 'Total enrolled and average',

  // end of journey scans -------------------------------------------------------------
  'end.of.journey.scans.status.to.process': 'To be processed',
  'end.of.journey.scans.status.processing': 'Processing',
  'end.of.journey.scans.status.processed': 'Processed',
  'end.of.journey.scans.status.failed': 'Failed',
  'end.of.journey.scans.failure.unreadable': 'Unreadable',
  'end.of.journey.scans.failure.unidentified': 'Youth not identified',
  'end.of.journey.scans.failure.enrollment.not.found': 'Youth not found',
  'end.of.journey.scans.failure.ambiguous.enrollment': 'Several possible youths',
  'end.of.journey.scans.failure.identity.mismatch': 'Identity mismatch',
  'end.of.journey.scans.failure.template.not.found': 'Template not found',
  'end.of.journey.scans.failure.already.received': 'Already received',
  'end.of.journey.scans.failure.invalid.answers': 'Invalid answers',
  'end.of.journey.scans.failure.extraction.error': 'Reading error',
  'end.of.journey.scans.page.title': 'Questionnaire processing',
  'end.of.journey.scans.page.upload.title': 'Send scanned questionnaires',
  'end.of.journey.scans.page.list.title': 'Questionnaires',
  'end.of.journey.scans.reading.paused.no.api.key':
    'Reading is paused: the questionnaires sent stay on hold and will be processed as soon as the reading key is configured.',
  'end.of.journey.scans.reading.paused.key.rejected':
    'Reading is paused: the questionnaires sent stay on hold and will be processed as soon as the reading key rejected by the service has been replaced.',
  'end.of.journey.scans.reading.paused.no.credit':
    'Reading is paused: the questionnaires sent stay on hold and will be processed as soon as the reading service credit has been topped up.',
  'end.of.journey.scans.reading.paused.rate.limited':
    'Reading is paused (reading service usage limit reached): the questionnaires sent stay on hold and will be processed as soon as the reading service is available again.',
  'end.of.journey.scans.reading.paused.overloaded':
    'Reading is paused (reading service overloaded): the questionnaires sent stay on hold and will be processed as soon as the reading service is available again.',
  'end.of.journey.scans.reading.paused.no.template':
    'Reading is paused: the questionnaires sent stay on hold and will be processed as soon as a questionnaire template with questions exists.',
  'end.of.journey.scans.reading.paused.since': 'Paused since {{date}}.',
  'end.of.journey.scans.reading.paused.resumes.automatically':
    'Processing will resume automatically.',
  'end.of.journey.scans.upload.help':
    'One PDF per questionnaire. Choose the files or drop them, or their folder, below. Each questionnaire is matched to the youth by its QR code (otherwise, by the enrollment number written on the copy).',
  'end.of.journey.scans.upload.help.limits':
    'One PDF per questionnaire (at most {{maxFiles}} PDFs per upload, at most {{maxFileMb}} MB each). Choose the files or drop them, or their folder, below. Each questionnaire is matched to the youth by its QR code (otherwise, by the enrollment number written on the copy).',
  'end.of.journey.scans.upload.drop.zone': 'Drop the PDFs or their folder here',
  'end.of.journey.scans.upload.choose.files': 'Choose the PDFs',
  'end.of.journey.scans.upload.ready': '{{number}} PDF(s) ready to send',
  'end.of.journey.scans.upload.progress': '{{done}} / {{total}} file(s) transferred',
  'end.of.journey.scans.upload.error.not.pdf': '{{fileName}}: not a PDF',
  'end.of.journey.scans.upload.error.limits':
    'The upload limits could not be loaded, no file can be chosen: {{message}}',
  'end.of.journey.scans.upload.error.too.large': '{{fileName}}: exceeds {{maxFileMb}} MB',
  'end.of.journey.scans.upload.error.too.many':
    '{{number}} PDFs chosen: at most {{maxFiles}} per upload, send them in several batches',
  'end.of.journey.scans.upload.error.failed': '{{fileName}}: the upload failed, send it again',
  'end.of.journey.scans.upload.success': '{{number}} questionnaire(s) sent: they will be read.',
  'end.of.journey.scans.upload.success.paused':
    '{{number}} questionnaire(s) received: reading is paused, they stay on hold and will be processed as soon as it resumes.',
  'end.of.journey.scans.upload.failed': '{{number}} file(s) could not be sent.',
  'end.of.journey.scans.send': 'Send',
  'end.of.journey.scans.cancel': 'Cancel',
  'end.of.journey.scans.tab.all': 'All',
  'end.of.journey.scans.filter.retried': 'Several attempts',
  'end.of.journey.scans.column.file': 'File',
  'end.of.journey.scans.column.status': 'Status',
  'end.of.journey.scans.column.youth': 'Youth',
  'end.of.journey.scans.column.attempts': 'Attempts',
  'end.of.journey.scans.column.ambiguous': 'Uncertain answers',
  'end.of.journey.scans.column.sent.at': 'Sent on',
  'end.of.journey.scans.template.id': 'Template #{{id}}',
  'end.of.journey.scans.stuck': 'Stuck in processing',
  'end.of.journey.scans.replace.existing': 'Will replace the received questionnaire',
  'end.of.journey.scans.ambiguous.count': '{{number}} uncertain',
  'end.of.journey.scans.blank.count': '{{number}} unanswered',
  'end.of.journey.scans.uncertain.type.several.marked': 'several boxes checked',
  'end.of.journey.scans.uncertain.type.unclear.mark': 'mark hard to read or too light',
  'end.of.journey.scans.uncertain.type.erased': 'answer erased or crossed out',
  'end.of.journey.scans.uncertain.type.outside.boxes': 'mark outside the boxes',
  'end.of.journey.scans.uncertain.type.other': 'other',
  'end.of.journey.scans.no.results': 'No questionnaire',
  'end.of.journey.scans.load.retry': 'Retry',
  'end.of.journey.scans.action.preview': 'View the scan',
  'end.of.journey.scans.action.reupload': 'Rescan',
  'end.of.journey.scans.action.retry': 'Retry',
  'end.of.journey.scans.action.replace': 'Replace',
  'end.of.journey.scans.action.manual': 'Manual entry',
  'end.of.journey.scans.action.correct': 'Correct',
  'end.of.journey.scans.preview.title': 'Scan',
  'end.of.journey.scans.preview.loading': 'Loading...',
  'end.of.journey.scans.preview.unavailable':
    'The scan is not available: it is still being scanned for viruses, or it was rejected by the antivirus.',
  'end.of.journey.scans.reupload.title': 'Rescan the questionnaire',
  'end.of.journey.scans.reupload.help': 'Scan this questionnaire again, on its own, as one PDF.',
  'end.of.journey.scans.reupload.choose.file': 'Choose the file',
  'end.of.journey.scans.reupload.error.not.pdf': 'The file is not a PDF',
  'end.of.journey.scans.reupload.error.too.large': 'The file exceeds {{maxFileMb}} MB',
  'end.of.journey.scans.replace.title': 'Replace the questionnaire?',
  'end.of.journey.scans.replace.subtitle':
    'This youth already has a saved questionnaire. Replace it with this entry?',
  'end.of.journey.scans.correct.title': 'Correct the questionnaire',
  'end.of.journey.scans.correct.note':
    '{{number}} uncertain answer(s) were left blank: check them on the scan.',
  'end.of.journey.scans.correct.note.blank':
    '{{number}} unanswered question(s) were left blank: check them on the scan.',
  'end.of.journey.scans.correct.note.both':
    '{{ambiguous}} uncertain answer(s) and {{blank}} unanswered question(s) were left blank: check them on the scan.',
  'end.of.journey.scans.retry.confirm.title': 'Relaunch the reading?',
  'end.of.journey.scans.retry.confirm.text':
    'The questionnaire "{{fileName}}" will be sent again to the automatic reading, with a new round of attempts.',
  'end.of.journey.scans.retry.replace.confirm.title': 'Relaunch the reading and replace?',
  'end.of.journey.scans.retry.replace.confirm.text':
    'The questionnaire "{{fileName}}" will be sent again to the automatic reading, with a new round of attempts. The questionnaire already received for this youth will be replaced.',
  'end.of.journey.scans.retry.success': 'The questionnaire will be retried.',
  'end.of.journey.scans.retry.success.paused':
    'The questionnaire is back on hold: reading is paused, it will be processed as soon as it resumes.',
  'end.of.journey.scans.reupload.success': 'The new scan will be processed.',
  'end.of.journey.scans.reupload.success.paused':
    'The new scan is received: reading is paused, it will be processed as soon as it resumes.',
  'end.of.journey.scans.resolve.success': 'Questionnaire saved.',
  'end.of.journey.scans.correct.success': 'Questionnaire corrected.',
  'end.of.journey.questionnaire.youth': 'Youth',
  'end.of.journey.questionnaire.not.answered': 'Not answered',
  'end.of.journey.questionnaire.blank.on.copy': 'Unanswered on the copy',
  'end.of.journey.questionnaire.rating': '{{rating}} / {{scaleMax}}',
  'end.of.journey.questionnaire.already.received':
    'This youth already has a questionnaire: it will be replaced after confirmation.',
  'end.of.journey.questionnaire.no.template':
    "No end-of-stay template is linked to this youth's stay.",
  'end.of.journey.questionnaire.cancel': 'Cancel',
  'end.of.journey.questionnaire.save': 'Save',

  // dynamic table toast messages -------------------------------------------------------------
  'dynamic.data.table.delete.success': 'Selected items have been successfully deleted.'
}
